(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5752,2576,2597,1620,5901,8960],{

/***/ 93228:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),

/***/ 51704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(52153);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 82941:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRange = __webpack_require__(93228),
    isIterateeCall = __webpack_require__(82406),
    toFinite = __webpack_require__(5707);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),

/***/ 52153:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 2689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createRange = __webpack_require__(82941);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),

/***/ 5707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(7642);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 7642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(51704),
    isObject = __webpack_require__(29259),
    isSymbol = __webpack_require__(4795);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 37870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ financial_services; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/templates/Footer/index.ts
var Footer = __webpack_require__(4009);
// EXTERNAL MODULE: ../../libs/templates/Navigation/index.ts + 91 modules
var Navigation = __webpack_require__(87303);
// EXTERNAL MODULE: ../../libs/templates/GettingStarted/index.ts + 2 modules
var GettingStarted = __webpack_require__(42576);
// EXTERNAL MODULE: ../../libs/next-shared/layout/index.ts
var layout = __webpack_require__(56052);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Hero/index.tsx + 2 modules
var recipes_Hero = __webpack_require__(84629);
// EXTERNAL MODULE: ../../libs/templates/Forms/DemoForm/index.ts + 3 modules
var DemoForm = __webpack_require__(98960);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/Hero/assets/Hero@2x.png
var Hero_2x = __webpack_require__(75394);
var Hero_2x_default = /*#__PURE__*/__webpack_require__.n(Hero_2x);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/Hero/assets/Hero.webp
var assets_Hero = __webpack_require__(63270);
var Hero_default = /*#__PURE__*/__webpack_require__.n(assets_Hero);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/Hero/assets/Hero@2x.webp
var assets_Hero_2x = __webpack_require__(70843);
var assets_Hero_2x_default = /*#__PURE__*/__webpack_require__.n(assets_Hero_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/Hero/Hero.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var copy = {
  heading: "Give every customer the \u2018personal finance\u2019 experience",
  description: "Deliver personalized experiences at scale using data that\u2019s complete, trustworthy, and compliant."
};

var Hero = function Hero() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* default */.ZP, {
      variant: "2Col",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(recipes_Hero/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            variant: "h1",
            tag: "h1",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            tag: "p",
            variant: "pExtraLarge",
            children: copy.description
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Form */.l0, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDemoForm, {
            isProgressive: true,
            customFormIdentifier: "site-industry-finserv-demo"
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Picture, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
            type: "image/webp",
            srcSet: "".concat((Hero_default()), ", ").concat((assets_Hero_2x_default()), " 2x")
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(recipes_Hero/* Image */.Ee, {
            width: "640",
            height: "540",
            src: (Hero_2x_default()),
            alt: "Illustration: Twilio Segment personal finance experience",
            loading: "lazy"
          })]
        })
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("header",  true ? {
  target: "ey2on82"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.green[10];
}, ";" + ( true ? "" : 0));

var StyledDemoForm = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(DemoForm/* default */.Z,  true ? {
  target: "ey2on81"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "ey2on80"
} : 0)("filter:drop-shadow(", function (_ref2) {
  var theme = _ref2.theme;
  return theme.shadows[2];
}, ");", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:540px;padding-top:80px;}" + ( true ? "" : 0));

/* harmony default export */ var Hero_Hero = (Hero);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/index.ts + 1 modules
var LogoCarousel = __webpack_require__(6087);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/LogoCarousel/LogoCarousel.tsx





var LogoCarousel_copy = {
  heading: "The world\u2019s most innovative companies build winning customer experiences with Segment"
};
var logos = [data/* carouselLogos.THE_MOTLEY_FOOL */.j.THE_MOTLEY_FOOL, data/* carouselLogos.CRYPTO_COM */.j.CRYPTO_COM, data/* carouselLogos.WEALTHSIMPLE */.j.WEALTHSIMPLE, data/* carouselLogos.CLEAR_SCORE */.j.CLEAR_SCORE, data/* carouselLogos.CHIME */.j.CHIME, data/* carouselLogos.EARNEST */.j.EARNEST, data/* carouselLogos.BETTER_MORTGAGE */.j.BETTER_MORTGAGE, data/* carouselLogos.TAXFIX */.j.TAXFIX];

var LogoCarouselComponent = function LogoCarouselComponent() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel["default"], {
          heading: LogoCarousel_copy.heading,
          logos: logos
        })
      })
    })
  });
};

var LogoCarousel_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e145jxcc1"
} : 0)( true ? "" : 0);

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e145jxcc0"
} : 0)(Section/* Wrapper */.im, "{padding-top:40px;padding-bottom:40px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("md");
}, "{padding-bottom:60px;}}" + ( true ? "" : 0));

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselComponent);
// EXTERNAL MODULE: ../../libs/templates/TestimonialSlider/index.ts + 11 modules
var TestimonialSlider = __webpack_require__(88302);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/CompanyMono.ts + 257 modules
var CompanyMono = __webpack_require__(41346);
// EXTERNAL MODULE: ../../libs/matcha/components/CompanyLogos/Company.ts + 265 modules
var Company = __webpack_require__(28392);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/Testimonials/data.tsx





var testimonialData = function testimonialData() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return [{
    company: "earnest",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* EarnestMonoLogo */.Iei, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* EarnestLogo */.LjI, {}),
    logoName: "Earnest"
  }, {
    company: "clear-score",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ClearScoreMonoLogo */.Ojb, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* ClearScoreLogo */.Kgu, {}),
    logoName: "ClearScore"
  }, {
    company: "toggle",
    logo: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanyMono/* ToggleMonoLogo */.nSO, {
      color: theme.palette.twilio.gray[70]
    }),
    logoActive: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Company/* ToggleLogo */.gwj, {}),
    logoName: "Toggle"
  }];
};


;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/Testimonials/Testimonials.tsx


function Testimonials_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var Testimonials = function Testimonials() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TestimonialSlider["default"], {
      innerStyles: false,
      title: false,
      data: testimonialData
    })
  });
};

var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "emg4lx0"
} : 0)( true ? {
  name: "ct1lmz",
  styles: "max-width:1260px;overflow-x:inherit"
} : 0);

/* harmony default export */ var Testimonials_Testimonials = (Testimonials);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/UseSegment/assets/UseSegment@2x.png
var UseSegment_2x = __webpack_require__(30862);
var UseSegment_2x_default = /*#__PURE__*/__webpack_require__.n(UseSegment_2x);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/UseSegment/assets/UseSegment.webp
var UseSegment = __webpack_require__(82738);
var UseSegment_default = /*#__PURE__*/__webpack_require__.n(UseSegment);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/UseSegment/assets/UseSegment@2x.webp
var assets_UseSegment_2x = __webpack_require__(41017);
var assets_UseSegment_2x_default = /*#__PURE__*/__webpack_require__.n(assets_UseSegment_2x);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/UseSegment/UseSegmentImage.tsx








var UseSegmentImage = function UseSegmentImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UseSegmentImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((UseSegment_default()), ", ").concat((assets_UseSegment_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (UseSegment_2x_default()),
      alt: "Illustration: Segment integrations",
      width: "941",
      height: "804",
      loading: "lazy"
    })]
  });
};

var UseSegmentImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e9jf9um0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var UseSegment_UseSegmentImage = (UseSegmentImage);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/UseSegment/UseSegment.tsx






var UseSegment_copy = {
  heading: "Use Segment to integrate with internal systems and best-in-class tools",
  description: "Activate audiences in ".concat("450", "+ marketing and analytics tools in real time.")
};

var UseSegment_UseSegment = function UseSegment() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseSegment_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      reverse: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionCopy, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: UseSegment_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            variant: "pLarge",
            tag: "p",
            children: UseSegment_copy.description
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UseSegment_UseSegmentImage, {})
      })]
    })
  });
};

var UseSegment_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ep2pb7o1"
} : 0)("display:grid;background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var SectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "ep2pb7o0"
} : 0)("display:flex;align-items:center;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:392px;justify-self:end;align-self:center;}" + ( true ? "" : 0));

/* harmony default export */ var components_UseSegment_UseSegment = (UseSegment_UseSegment);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 21 modules
var motion_minimal = __webpack_require__(48714);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/ButtonText/index.ts
var ButtonText = __webpack_require__(74870);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/CentralizeAndSimplify/assets/CentralizeAndSimplify@2x.png
var CentralizeAndSimplify_2x = __webpack_require__(74613);
var CentralizeAndSimplify_2x_default = /*#__PURE__*/__webpack_require__.n(CentralizeAndSimplify_2x);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/CentralizeAndSimplify/assets/CentralizeAndSimplify.webp
var CentralizeAndSimplify = __webpack_require__(77732);
var CentralizeAndSimplify_default = /*#__PURE__*/__webpack_require__.n(CentralizeAndSimplify);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/CentralizeAndSimplify/assets/CentralizeAndSimplify@2x.webp
var assets_CentralizeAndSimplify_2x = __webpack_require__(81355);
var assets_CentralizeAndSimplify_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CentralizeAndSimplify_2x);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/CentralizeAndSimplify/CentralizeAndSimplifyImage.tsx








var CentralizeAndSimplifyImage = function CentralizeAndSimplifyImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CentralizeAndSimplifyImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CentralizeAndSimplify_default()), ", ").concat((assets_CentralizeAndSimplify_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (CentralizeAndSimplify_2x_default()),
      alt: "Illustration: Centralize and simplify",
      width: "640",
      height: "410",
      loading: "lazy"
    })]
  });
};

var CentralizeAndSimplifyImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1n2319g0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var CentralizeAndSimplify_CentralizeAndSimplifyImage = (CentralizeAndSimplifyImage);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/CentralizeAndSimplify/CentralizeAndSimplify.tsx


function CentralizeAndSimplify_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var CentralizeAndSimplify_copy = {
  heading: "Centralize and simplify customer data collection across online and offline touchpoints"
};
var list = [{
  title: "Collect",
  description: "See the complete view of your customer by unifying data across web, mobile web, apps, email, support, and offline interactions."
}, {
  title: "Understand",
  description: "Identify traits of your high value customers and uncover key events along the customer journey that impact growth, engagement, and retention."
}, {
  title: "Centralize",
  description: "Centralize and scale access to high-quality, secure data and deliver it to the tools and internal teams that need it."
}];
var CentralizeAndSimplify_link = {
  href: "/product/connections/",
  text: "Explore Connections"
};

var CentralizeAndSimplify_CentralizeAndSimplify = function CentralizeAndSimplify() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    copyVariant: "narrow",
    sticky: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: CentralizeAndSimplify_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnTrack/* default */.Z, {
          gap: "medium",
          children: [list.map(function (_ref) {
            var title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
              alignment: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  tag: "h3",
                  variant: "h5",
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: description
                })]
              })
            }, title);
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
              tag: "a",
              href: (0,getAbsoluteUrl/* default */.Z)(CentralizeAndSimplify_link.href, pageConfig),
              target: "_blank",
              iconEnd: Common/* ChevronRightIcon */.XC,
              children: CentralizeAndSimplify_link.text
            })
          })]
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Sticky */.Le, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageWrapper, {
          initial: {
            opacity: 0
          },
          whileInView: {
            opacity: 1,
            transition: {
              duration: 0.4,
              delay: 0.1
            }
          },
          viewport: {
            once: true
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CentralizeAndSimplify_CentralizeAndSimplifyImage, {})
        })
      })
    })]
  });
};

/* harmony default export */ var components_CentralizeAndSimplify_CentralizeAndSimplify = (CentralizeAndSimplify_CentralizeAndSimplify);

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15luuhl2"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15luuhl1"
} : 0)( true ? "" : 0);

var ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e15luuhl0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/PersonalizeEveryInteraction/assets/PersonalizeEveryInteraction@2x.png
var PersonalizeEveryInteraction_2x = __webpack_require__(98309);
var PersonalizeEveryInteraction_2x_default = /*#__PURE__*/__webpack_require__.n(PersonalizeEveryInteraction_2x);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/PersonalizeEveryInteraction/assets/PersonalizeEveryInteraction.webp
var PersonalizeEveryInteraction = __webpack_require__(27070);
var PersonalizeEveryInteraction_default = /*#__PURE__*/__webpack_require__.n(PersonalizeEveryInteraction);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/PersonalizeEveryInteraction/assets/PersonalizeEveryInteraction@2x.webp
var assets_PersonalizeEveryInteraction_2x = __webpack_require__(52436);
var assets_PersonalizeEveryInteraction_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PersonalizeEveryInteraction_2x);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/PersonalizeEveryInteraction/PersonalizeEveryInteractionImage.tsx








var PersonalizeEveryInteractionImage = function PersonalizeEveryInteractionImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PersonalizeEveryInteractionImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((PersonalizeEveryInteraction_default()), ", ").concat((assets_PersonalizeEveryInteraction_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (PersonalizeEveryInteraction_2x_default()),
      alt: "Illustration: Personalize every interaction",
      width: "946",
      height: "625",
      loading: "lazy"
    })]
  });
};

var PersonalizeEveryInteractionImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "ehtsx4i0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var PersonalizeEveryInteraction_PersonalizeEveryInteractionImage = (PersonalizeEveryInteractionImage);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/PersonalizeEveryInteraction/PersonalizeEveryInteraction.tsx


function PersonalizeEveryInteraction_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var PersonalizeEveryInteraction_copy = {
  heading: "Personalize every interaction across the omnichannel customer journey"
};
var PersonalizeEveryInteraction_link = {
  text: "Explore Twilio Engage",
  url: "/product/twilio-engage/"
};
var PersonalizeEveryInteraction_list = [{
  title: "Build",
  description: "Create real-time audiences and campaigns without relying on your engineering team."
}, {
  title: "Engage",
  description: "Deliver personalized experiences wherever your customers are, whether in a local branch or online."
}, {
  title: "Retain",
  description: "Use individualized data to drive the behaviors or product features that increase customer loyalty and engagement."
}];

var PersonalizeEveryInteraction_PersonalizeEveryInteraction = function PersonalizeEveryInteraction() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
    variant: "2Col",
    copyVariant: "narrow",
    sticky: true,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: PersonalizeEveryInteraction_copy.heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizeEveryInteraction_ColumnTrackWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnTrack/* default */.Z, {
          gap: "medium",
          children: [PersonalizeEveryInteraction_list.map(function (_ref) {
            var title = _ref.title,
                description = _ref.description;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
              alignment: "left",
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                  tag: "h3",
                  variant: "h5",
                  children: title
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                  children: description
                })]
              })
            }, title);
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizeEveryInteraction_ButtonWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
              tag: "a",
              href: (0,getAbsoluteUrl/* default */.Z)(PersonalizeEveryInteraction_link.url, pageConfig),
              target: "_blank",
              iconEnd: Common/* ChevronRightIcon */.XC,
              children: PersonalizeEveryInteraction_link.text
            })
          })]
        })
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Sticky */.Le, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizeEveryInteraction_ImageWrapper, {
          initial: {
            opacity: 0
          },
          whileInView: {
            opacity: 1,
            transition: {
              duration: 0.4,
              delay: 0.1
            }
          },
          viewport: {
            once: true
          },
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PersonalizeEveryInteraction_PersonalizeEveryInteractionImage, {})
        })
      })
    })]
  });
};

/* harmony default export */ var components_PersonalizeEveryInteraction_PersonalizeEveryInteraction = (PersonalizeEveryInteraction_PersonalizeEveryInteraction);

var PersonalizeEveryInteraction_ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8o8ma12"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var PersonalizeEveryInteraction_ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e8o8ma11"
} : 0)( true ? "" : 0);

var PersonalizeEveryInteraction_ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e8o8ma10"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/MakeInformedDecisions/assets/MakeInformedDecisions@2x.png
var MakeInformedDecisions_2x = __webpack_require__(70532);
var MakeInformedDecisions_2x_default = /*#__PURE__*/__webpack_require__.n(MakeInformedDecisions_2x);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/MakeInformedDecisions/assets/MakeInformedDecisions.webp
var MakeInformedDecisions = __webpack_require__(27286);
var MakeInformedDecisions_default = /*#__PURE__*/__webpack_require__.n(MakeInformedDecisions);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/MakeInformedDecisions/assets/MakeInformedDecisions@2x.webp
var assets_MakeInformedDecisions_2x = __webpack_require__(9841);
var assets_MakeInformedDecisions_2x_default = /*#__PURE__*/__webpack_require__.n(assets_MakeInformedDecisions_2x);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/MakeInformedDecisions/MakeInformedDecisionsImage.tsx








var MakeInformedDecisionsImage = function MakeInformedDecisionsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MakeInformedDecisionsImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((MakeInformedDecisions_default()), ", ").concat((assets_MakeInformedDecisions_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      src: (MakeInformedDecisions_2x_default()),
      alt: "Illustration: Clean and compliant customer data",
      width: "961",
      height: "810",
      loading: "lazy"
    })]
  });
};

var MakeInformedDecisionsImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e15ikyig0"
} : 0)("filter:drop-shadow(", function (_ref) {
  var theme = _ref.theme;
  return theme.shadows[2];
}, ");" + ( true ? "" : 0));

/* harmony default export */ var MakeInformedDecisions_MakeInformedDecisionsImage = (MakeInformedDecisionsImage);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/MakeInformedDecisions/MakeInformedDecisions.tsx


function MakeInformedDecisions_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var MakeInformedDecisions_copy = {
  heading: "Make informed decisions with clean and compliant customer data"
};
var MakeInformedDecisions_list = [{
  title: "Trust",
  description: "Power your tools and product cross-sell recommendations with clean, reliable data."
}, {
  title: "Empower",
  description: "Align your teams and tools with secure and consistent customer data."
}, {
  title: "Protect",
  description: "Simplify compliance with automated data governance and real-time PII screening."
}];
var MakeInformedDecisions_link = {
  href: "/product/protocols/",
  text: "Explore Protocols"
};

var MakeInformedDecisions_MakeInformedDecisions = function MakeInformedDecisions() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeInformedDecisions_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      reverse: true,
      copyVariant: "narrow",
      sticky: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* default */.ZP, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            tag: "h2",
            children: MakeInformedDecisions_copy.heading
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeInformedDecisions_ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ColumnTrack/* default */.Z, {
            gap: "medium",
            children: [MakeInformedDecisions_list.map(function (_ref) {
              var title = _ref.title,
                  description = _ref.description;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* default */.ZP, {
                alignment: "left",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    tag: "h3",
                    variant: "h5",
                    children: title
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                    children: description
                  })]
                })
              }, title);
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeInformedDecisions_ButtonWrapper, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonText/* default */.Z, {
                tag: "a",
                href: (0,getAbsoluteUrl/* default */.Z)(MakeInformedDecisions_link.href, pageConfig),
                target: "_blank",
                iconEnd: Common/* ChevronRightIcon */.XC,
                children: MakeInformedDecisions_link.text
              })
            })]
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Sticky */.Le, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeInformedDecisions_ImageWrapper, {
            initial: {
              opacity: 0
            },
            whileInView: {
              opacity: 1,
              transition: {
                duration: 0.4,
                delay: 0.1
              }
            },
            viewport: {
              once: true
            },
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MakeInformedDecisions_MakeInformedDecisionsImage, {})
          })
        })
      })]
    })
  });
};

/* harmony default export */ var components_MakeInformedDecisions_MakeInformedDecisions = (MakeInformedDecisions_MakeInformedDecisions);

var MakeInformedDecisions_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yfu3863"
} : 0)("background:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var MakeInformedDecisions_ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yfu3862"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var MakeInformedDecisions_ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1yfu3861"
} : 0)( true ? "" : 0);

var MakeInformedDecisions_ImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(motion_minimal.m.div,  true ? {
  target: "e1yfu3860"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/recipes/PropCard/index.ts + 6 modules
var PropCard = __webpack_require__(62456);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/PropCardCta/assets/PropCardCta@2x.png
var PropCardCta_2x = __webpack_require__(9968);
var PropCardCta_2x_default = /*#__PURE__*/__webpack_require__.n(PropCardCta_2x);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/PropCardCta/assets/PropCardCta.webp
var PropCardCta = __webpack_require__(65347);
var PropCardCta_default = /*#__PURE__*/__webpack_require__.n(PropCardCta);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/components/PropCardCta/assets/PropCardCta@2x.webp
var assets_PropCardCta_2x = __webpack_require__(9669);
var assets_PropCardCta_2x_default = /*#__PURE__*/__webpack_require__.n(assets_PropCardCta_2x);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/PropCardCta/PropCardCtaImage.tsx


function PropCardCtaImage_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var PropCardCtaImage = function PropCardCtaImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCardCtaImage_Picture, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((PropCardCta_default()), ", ").concat((assets_PropCardCta_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, {
      src: (PropCardCta_2x_default()),
      alt: "Guide: Why Every Fintech Business Needs a CDP",
      width: "640",
      height: "469",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var PropCardCta_PropCardCtaImage = (PropCardCtaImage);

var PropCardCtaImage_Picture = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("picture",  true ? {
  target: "e1yaqnwn1"
} : 0)( true ? {
  name: "s5xdrg",
  styles: "display:flex;align-items:center"
} : 0);

var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Image/* default */.Z,  true ? {
  target: "e1yaqnwn0"
} : 0)("max-width:200px;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("sm");
}, "{max-width:250px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/PropCardCta/PropCardCta.tsx


function PropCardCta_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }








var PropCardCta_copy = {
  heading: "Why Every Fintech Business Needs a CDP",
  paragraph: "In this guide we discuss why a customer data platform may be the key ingredient for financial services & technology companies."
};
var PropCardCta_button = {
  text: "Access the guide",
  url: "https://learn.segment.com/why-fintech-needs-a-cdp/"
};

var PropCardCta_PropCardCta = function PropCardCta() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCardCta_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
      variant: "noCopy",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
          columns: 1,
          center: true,
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPropCardBase, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PropCard/* Copy */.CK, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Title */.Dx, {
                children: PropCardCta_copy.heading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Text */.xv, {
                children: PropCardCta_copy.paragraph
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                href: PropCardCta_button.url,
                tag: "a",
                size: "large",
                color: "primary",
                variant: "filled",
                children: PropCardCta_button.text
              })]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCard/* Img */.Ei, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropCardCta_PropCardCtaImage, {})
            })]
          })
        })
      })
    })
  });
};

var PropCardCta_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "entlvz32"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.twilio.gray[10];
}, ";" + ( true ? "" : 0));

var StyledPropCardBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(PropCard/* default */.ZP,  true ? {
  target: "entlvz31"
} : 0)(function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down("xs");
}, "{grid-template-areas:'img ' 'copy';}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "entlvz30"
} : 0)( true ? {
  name: "1uv04q2",
  styles: "max-width:720px;margin:0 auto;row-reverse:reverse"
} : 0);

/* harmony default export */ var components_PropCardCta_PropCardCta = (PropCardCta_PropCardCta);
// EXTERNAL MODULE: ../../libs/matcha/components/Figure/index.ts + 1 modules
var Figure = __webpack_require__(95976);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/SecurityHighlight/assets/BadgeIso27001.svg
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBadgeIso27001 = function SvgBadgeIso27001(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 140,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "#606B85",
    fillRule: "evenodd",
    d: "M93.639 20.063h3.159A43.497 43.497 0 0 0 80.992 5.346 43.83 43.83 0 0 0 60.009 0a43.83 43.83 0 0 0-20.983 5.346A43.498 43.498 0 0 0 23.22 20.063h3.159a41.382 41.382 0 0 1 7.024-7.681 88.814 88.814 0 0 0 13.565 2.543 64.238 64.238 0 0 0-1.487 5.138h2.68a59.09 59.09 0 0 1 1.468-4.87 121.877 121.877 0 0 0 20.78.055 58.819 58.819 0 0 1 1.447 4.816h2.68a65.197 65.197 0 0 0-1.463-5.07 89.277 89.277 0 0 0 13.674-2.5 41.239 41.239 0 0 1 6.892 7.57Zm-45.755-7.647a90.718 90.718 0 0 1-11.914-2.043 42.14 42.14 0 0 1 17.709-7.454c-2.082 2.101-4.19 5.442-5.795 9.497Zm12.396.654c-3.28 0-6.528-.137-9.682-.397 2.69-6.407 6.104-10.263 9.41-10.263 3.313 0 6.737 3.872 9.429 10.304-2.992.233-6.064.355-9.157.356Zm11.875-.601c-1.612-4.082-3.725-7.44-5.817-9.55a42.125 42.125 0 0 1 17.845 7.552 92.11 92.11 0 0 1-12.028 1.998Zm-2.68 23.276V24.453H60.35a71.281 71.281 0 0 0-8.455-.666c-10.515 0-17.718 3.824-17.718 12.27 0 10.315 9.282 11.44 16.33 12.295 4.31.523 7.785.944 7.785 3.306 0 1.913-1.925 2.98-6.666 2.98-3.58 0-6.71-.757-8.052-1.467v-2.402h-9.128V62.06h9.128c2.966.393 5.954.615 8.946.667 13.825 0 18.433-5.6 18.433-12.446 0-10.127-9.129-11.201-16.204-12.034-4.478-.527-8.133-.958-8.133-3.524 0-1.601 1.655-2.845 5.904-2.845 3.312 0 6.487.757 7.83 1.466v2.4h9.126Zm2.382 30.858a59.315 59.315 0 0 1-1.468 4.87 121.606 121.606 0 0 0-20.78-.054 58.597 58.597 0 0 1-1.447-4.816h-2.68a64.21 64.21 0 0 0 1.464 5.069 89.127 89.127 0 0 0-13.675 2.502 41.347 41.347 0 0 1-6.891-7.571h-3.16A43.497 43.497 0 0 0 39.026 81.32a43.83 43.83 0 0 0 20.983 5.346 43.83 43.83 0 0 0 20.983-5.346 43.497 43.497 0 0 0 15.805-14.718H93.64a41.258 41.258 0 0 1-7.026 7.682 88.853 88.853 0 0 0-13.564-2.543 64.376 64.376 0 0 0 1.488-5.14h-2.681Zm-36.022 9.593c3.96-.93 7.98-1.598 12.03-1.999 1.61 4.081 3.724 7.44 5.815 9.55a42.127 42.127 0 0 1-17.845-7.55Zm24.175 8.06c-3.313 0-6.736-3.87-9.43-10.304a117.996 117.996 0 0 1 18.84.042c-2.69 6.407-6.105 10.262-9.41 10.262Zm24.04-7.961a42.165 42.165 0 0 1-17.71 7.452c2.082-2.102 4.188-5.44 5.795-9.496a90.291 90.291 0 0 1 11.914 2.044ZM7.331 62.138v-9.335h6.128V33.865H7.332v-9.336h24.382v9.335h-6.13v18.939h6.13v9.335H7.332ZM72.57 43.257c0-12.492 8.635-19.47 20.715-19.47 12.078 0 20.714 6.978 20.714 19.47 0 12.492-8.636 19.47-20.714 19.47-12.08 0-20.715-6.978-20.715-19.47Zm12.885 0c0 7.602 3.042 10.624 7.83 10.624 4.786 0 7.829-3.022 7.829-10.624 0-7.6-3.043-10.622-7.829-10.622-4.788 0-7.83 3.022-7.83 10.622Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#606B85",
    d: "M17.352 130h2.934v-12.87h-2.934V130Zm10.282.198c3.042 0 4.914-1.818 4.914-4.104 0-2.664-1.602-3.51-4.716-3.906-1.98-.288-2.394-.72-2.394-1.638 0-.864.648-1.458 1.926-1.458s1.962.54 2.142 1.71h2.682c-.234-2.556-1.926-3.852-4.824-3.852-2.844 0-4.68 1.638-4.68 3.834 0 2.484 1.35 3.474 4.644 3.906 1.89.288 2.43.648 2.43 1.674 0 1.008-.846 1.71-2.124 1.71-1.908 0-2.394-.954-2.52-2.106h-2.79c.162 2.574 1.782 4.23 5.31 4.23Zm12.92-2.322c-2.106 0-3.618-1.62-3.618-4.248v-.144c0-2.592 1.35-4.23 3.582-4.23 2.25 0 3.582 1.71 3.582 4.212v.144c0 2.592-1.368 4.266-3.546 4.266Zm-.054 2.322c4.014 0 6.642-2.79 6.642-6.624v-.144c0-3.87-2.754-6.48-6.624-6.48-3.816 0-6.624 2.718-6.624 6.552v.144c0 3.762 2.574 6.552 6.606 6.552ZM52.075 130h9.72v-2.214h-5.004l2.43-2.376c1.494-1.44 2.484-2.844 2.484-4.554 0-2.322-1.62-3.906-4.464-3.906-2.88 0-4.68 1.62-4.824 4.59h2.646c.198-1.692.918-2.358 2.052-2.358 1.116 0 1.71.684 1.71 1.746 0 1.17-.792 2.304-2.034 3.618l-4.716 4.986V130Zm12.598 0h2.97l4.608-12.546v-.324h-9.324v2.358h5.67L64.673 130Zm13.828-2.088c-1.8 0-2.754-1.35-2.754-4.05v-.612c0-2.664.918-4.05 2.719-4.05 1.782 0 2.681 1.458 2.681 4.05v.576c0 2.7-.828 4.086-2.646 4.086Zm-.072 2.286c3.474 0 5.617-2.448 5.617-6.39v-.594c0-3.996-2.287-6.264-5.599-6.264-3.312 0-5.615 2.358-5.615 6.318v.612c0 3.942 2.178 6.318 5.598 6.318Zm12.904-2.286c-1.8 0-2.754-1.35-2.754-4.05v-.612c0-2.664.919-4.05 2.719-4.05 1.781 0 2.681 1.458 2.681 4.05v.576c0 2.7-.828 4.086-2.645 4.086Zm-.072 2.286c3.475 0 5.617-2.448 5.617-6.39v-.594c0-3.996-2.287-6.264-5.599-6.264-3.311 0-5.615 2.358-5.615 6.318v.612c0 3.942 2.177 6.318 5.597 6.318Zm9.611-.198h2.916v-12.87h-2.556l-2.97 2.106v2.484l2.61-1.71V130Z"
  })));
};
/* harmony default export */ var BadgeIso27001 = (SvgBadgeIso27001);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/SecurityHighlight/assets/BadgeIso27017.svg
var BadgeIso27017_path, BadgeIso27017_path2;
function BadgeIso27017_extends() { BadgeIso27017_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return BadgeIso27017_extends.apply(this, arguments); }

var SvgBadgeIso27017 = function SvgBadgeIso27017(props) {
  return /*#__PURE__*/react.createElement("svg", BadgeIso27017_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 140,
    fill: "none"
  }, props), BadgeIso27017_path || (BadgeIso27017_path = /*#__PURE__*/react.createElement("path", {
    fill: "#606B85",
    fillRule: "evenodd",
    d: "M90.973 20.063h3.159A43.497 43.497 0 0 0 78.326 5.346 43.83 43.83 0 0 0 57.343 0 43.83 43.83 0 0 0 36.36 5.346a43.497 43.497 0 0 0-15.806 14.717h3.159a41.379 41.379 0 0 1 7.024-7.681 88.812 88.812 0 0 0 13.565 2.543 64.238 64.238 0 0 0-1.487 5.138h2.68a59.09 59.09 0 0 1 1.468-4.87 121.878 121.878 0 0 0 20.78.055 58.858 58.858 0 0 1 1.447 4.816h2.68a65.153 65.153 0 0 0-1.463-5.07 89.276 89.276 0 0 0 13.674-2.5 41.239 41.239 0 0 1 6.892 7.57Zm-45.755-7.647a90.718 90.718 0 0 1-11.914-2.043 42.14 42.14 0 0 1 17.709-7.454c-2.082 2.101-4.19 5.442-5.795 9.497Zm12.396.654c-3.28 0-6.528-.137-9.682-.397 2.69-6.407 6.104-10.263 9.41-10.263 3.313 0 6.737 3.872 9.429 10.304a118.62 118.62 0 0 1-9.157.356Zm11.875-.601c-1.612-4.082-3.725-7.44-5.817-9.55a42.126 42.126 0 0 1 17.845 7.552 92.113 92.113 0 0 1-12.028 1.998Zm-2.68 23.276V24.453h-9.127a71.281 71.281 0 0 0-8.455-.666c-10.514 0-17.717 3.824-17.717 12.27 0 10.315 9.282 11.44 16.33 12.295 4.31.523 7.785.944 7.785 3.306 0 1.913-1.925 2.98-6.666 2.98-3.58 0-6.71-.757-8.052-1.467v-2.402h-9.128V62.06h9.128c2.966.393 5.954.615 8.946.667 13.825 0 18.433-5.6 18.433-12.446 0-10.127-9.129-11.201-16.204-12.034-4.478-.527-8.133-.958-8.133-3.524 0-1.601 1.655-2.845 5.904-2.845 3.312 0 6.487.757 7.83 1.466v2.4h9.126Zm2.382 30.858a59.277 59.277 0 0 1-1.468 4.87 121.606 121.606 0 0 0-20.78-.054 58.596 58.596 0 0 1-1.447-4.816h-2.68a64.21 64.21 0 0 0 1.464 5.069 89.127 89.127 0 0 0-13.675 2.502 41.347 41.347 0 0 1-6.891-7.571h-3.16A43.497 43.497 0 0 0 36.36 81.32a43.83 43.83 0 0 0 20.983 5.346 43.83 43.83 0 0 0 20.983-5.346 43.497 43.497 0 0 0 15.806-14.718h-3.158a41.261 41.261 0 0 1-7.026 7.682 88.854 88.854 0 0 0-13.564-2.543 64.334 64.334 0 0 0 1.488-5.14H69.19Zm-36.022 9.593c3.96-.93 7.98-1.598 12.03-1.999 1.61 4.081 3.724 7.44 5.815 9.55a42.127 42.127 0 0 1-17.845-7.55Zm24.175 8.06c-3.313 0-6.736-3.87-9.43-10.304a117.996 117.996 0 0 1 18.84.042c-2.69 6.407-6.105 10.262-9.41 10.262Zm24.04-7.961a42.165 42.165 0 0 1-17.71 7.452c2.082-2.102 4.188-5.44 5.795-9.496a90.291 90.291 0 0 1 11.914 2.044ZM4.665 62.138v-9.335h6.128V33.865H4.666v-9.336h24.382v9.335h-6.13v18.939h6.13v9.335H4.666Zm65.238-18.881c0-12.492 8.635-19.47 20.715-19.47 12.078 0 20.714 6.978 20.714 19.47 0 12.492-8.636 19.47-20.714 19.47-12.08 0-20.715-6.978-20.715-19.47Zm12.885 0c0 7.602 3.042 10.624 7.83 10.624 4.786 0 7.829-3.022 7.829-10.624 0-7.6-3.043-10.622-7.829-10.622-4.788 0-7.83 3.022-7.83 10.622Z",
    clipRule: "evenodd"
  })), BadgeIso27017_path2 || (BadgeIso27017_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#606B85",
    d: "M16.75 130h2.934v-12.87H16.75V130Zm10.282.198c3.041 0 4.913-1.818 4.913-4.104 0-2.664-1.602-3.51-4.715-3.906-1.98-.288-2.395-.72-2.395-1.638 0-.864.648-1.458 1.927-1.458 1.277 0 1.962.54 2.142 1.71h2.681c-.233-2.556-1.925-3.852-4.823-3.852-2.845 0-4.68 1.638-4.68 3.834 0 2.484 1.35 3.474 4.643 3.906 1.89.288 2.43.648 2.43 1.674 0 1.008-.846 1.71-2.123 1.71-1.909 0-2.395-.954-2.52-2.106h-2.79c.162 2.574 1.781 4.23 5.31 4.23Zm12.92-2.322c-2.107 0-3.619-1.62-3.619-4.248v-.144c0-2.592 1.35-4.23 3.582-4.23 2.25 0 3.582 1.71 3.582 4.212v.144c0 2.592-1.368 4.266-3.546 4.266Zm-.055 2.322c4.014 0 6.642-2.79 6.642-6.624v-.144c0-3.87-2.754-6.48-6.624-6.48-3.816 0-6.624 2.718-6.624 6.552v.144c0 3.762 2.574 6.552 6.606 6.552ZM51.473 130h9.72v-2.214h-5.004l2.43-2.376c1.494-1.44 2.484-2.844 2.484-4.554 0-2.322-1.62-3.906-4.464-3.906-2.88 0-4.68 1.62-4.824 4.59h2.646c.198-1.692.918-2.358 2.052-2.358 1.116 0 1.71.684 1.71 1.746 0 1.17-.792 2.304-2.034 3.618l-4.716 4.986V130Zm12.598 0h2.97l4.608-12.546v-.324h-9.324v2.358h5.67L64.07 130Zm13.828-2.088c-1.8 0-2.754-1.35-2.754-4.05v-.612c0-2.664.918-4.05 2.718-4.05 1.782 0 2.682 1.458 2.682 4.05v.576c0 2.7-.828 4.086-2.646 4.086Zm-.072 2.286c3.474 0 5.616-2.448 5.616-6.39v-.594c0-3.996-2.286-6.264-5.598-6.264s-5.616 2.358-5.616 6.318v.612c0 3.942 2.178 6.318 5.598 6.318Zm9.61-.198h2.916v-12.87h-2.556l-2.97 2.106v2.484l2.61-1.71V130Zm6.798 0h2.97l4.608-12.546v-.324h-9.324v2.358h5.67L94.235 130Z"
  })));
};
/* harmony default export */ var BadgeIso27017 = (SvgBadgeIso27017);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/SecurityHighlight/assets/BadgeIso27018.svg
var BadgeIso27018_path, BadgeIso27018_path2;
function BadgeIso27018_extends() { BadgeIso27018_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return BadgeIso27018_extends.apply(this, arguments); }

var SvgBadgeIso27018 = function SvgBadgeIso27018(props) {
  return /*#__PURE__*/react.createElement("svg", BadgeIso27018_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 140,
    fill: "none"
  }, props), BadgeIso27018_path || (BadgeIso27018_path = /*#__PURE__*/react.createElement("path", {
    fill: "#606B85",
    fillRule: "evenodd",
    d: "M92.307 20.063h3.159A43.497 43.497 0 0 0 79.66 5.346 43.83 43.83 0 0 0 58.677 0a43.83 43.83 0 0 0-20.983 5.346 43.497 43.497 0 0 0-15.806 14.717h3.159a41.376 41.376 0 0 1 7.024-7.681 88.812 88.812 0 0 0 13.565 2.543 64.196 64.196 0 0 0-1.487 5.138h2.68a59.05 59.05 0 0 1 1.468-4.87 121.878 121.878 0 0 0 20.78.055 58.858 58.858 0 0 1 1.447 4.816h2.68a65.153 65.153 0 0 0-1.463-5.07 89.278 89.278 0 0 0 13.674-2.5 41.246 41.246 0 0 1 6.892 7.57Zm-45.755-7.647a90.717 90.717 0 0 1-11.914-2.043 42.14 42.14 0 0 1 17.709-7.454c-2.082 2.101-4.19 5.442-5.795 9.497Zm12.396.654c-3.28 0-6.528-.137-9.682-.397 2.69-6.407 6.104-10.263 9.41-10.263 3.313 0 6.737 3.872 9.429 10.304a118.62 118.62 0 0 1-9.157.356Zm11.875-.601c-1.612-4.082-3.725-7.44-5.817-9.55a42.126 42.126 0 0 1 17.845 7.552 92.116 92.116 0 0 1-12.028 1.998Zm-2.68 23.276V24.453h-9.127a71.283 71.283 0 0 0-8.455-.666c-10.514 0-17.717 3.824-17.717 12.27 0 10.315 9.282 11.44 16.33 12.295 4.31.523 7.785.944 7.785 3.306 0 1.913-1.925 2.98-6.666 2.98-3.58 0-6.711-.757-8.053-1.467v-2.402h-9.127V62.06h9.127a78.61 78.61 0 0 0 8.947.667c13.825 0 18.433-5.6 18.433-12.446 0-10.127-9.129-11.201-16.204-12.034-4.478-.527-8.133-.958-8.133-3.524 0-1.601 1.655-2.845 5.904-2.845 3.312 0 6.487.757 7.83 1.466v2.4h9.126Zm2.382 30.858a59.277 59.277 0 0 1-1.468 4.87 121.608 121.608 0 0 0-20.78-.054 58.636 58.636 0 0 1-1.447-4.816h-2.68a64.167 64.167 0 0 0 1.464 5.069 89.13 89.13 0 0 0-13.675 2.502 41.347 41.347 0 0 1-6.891-7.571h-3.16A43.497 43.497 0 0 0 37.694 81.32a43.83 43.83 0 0 0 20.983 5.346A43.83 43.83 0 0 0 79.66 81.32a43.497 43.497 0 0 0 15.806-14.718h-3.158a41.254 41.254 0 0 1-7.026 7.682 88.853 88.853 0 0 0-13.564-2.543 64.334 64.334 0 0 0 1.488-5.14h-2.681Zm-36.022 9.593a92.34 92.34 0 0 1 12.03-1.999c1.61 4.081 3.724 7.44 5.815 9.55a42.128 42.128 0 0 1-17.845-7.55Zm24.175 8.06c-3.313 0-6.736-3.87-9.43-10.304a117.996 117.996 0 0 1 18.84.042c-2.69 6.407-6.105 10.262-9.41 10.262Zm24.04-7.961a42.165 42.165 0 0 1-17.71 7.452c2.082-2.102 4.188-5.44 5.795-9.496a90.291 90.291 0 0 1 11.914 2.044ZM6 62.138v-9.335h6.128V33.865H6v-9.336h24.382v9.335h-6.13v18.939h6.13v9.335H6Zm65.238-18.881c0-12.492 8.635-19.47 20.715-19.47 12.078 0 20.714 6.978 20.714 19.47 0 12.492-8.636 19.47-20.714 19.47-12.08 0-20.715-6.978-20.715-19.47Zm12.885 0c0 7.602 3.042 10.624 7.83 10.624 4.786 0 7.828-3.022 7.828-10.624 0-7.6-3.042-10.622-7.828-10.622-4.788 0-7.83 3.022-7.83 10.622Z",
    clipRule: "evenodd"
  })), BadgeIso27018_path2 || (BadgeIso27018_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#606B85",
    d: "M17.354 130h2.934v-12.87h-2.934V130Zm10.281.198c3.042 0 4.914-1.818 4.914-4.104 0-2.664-1.602-3.51-4.716-3.906-1.98-.288-2.394-.72-2.394-1.638 0-.864.648-1.458 1.926-1.458s1.962.54 2.142 1.71h2.682c-.234-2.556-1.926-3.852-4.824-3.852-2.844 0-4.68 1.638-4.68 3.834 0 2.484 1.35 3.474 4.644 3.906 1.89.288 2.43.648 2.43 1.674 0 1.008-.846 1.71-2.124 1.71-1.908 0-2.394-.954-2.52-2.106h-2.79c.162 2.574 1.782 4.23 5.31 4.23Zm12.92-2.322c-2.106 0-3.618-1.62-3.618-4.248v-.144c0-2.592 1.35-4.23 3.582-4.23 2.25 0 3.582 1.71 3.582 4.212v.144c0 2.592-1.368 4.266-3.546 4.266Zm-.054 2.322c4.014 0 6.642-2.79 6.642-6.624v-.144c0-3.87-2.754-6.48-6.624-6.48-3.816 0-6.624 2.718-6.624 6.552v.144c0 3.762 2.574 6.552 6.606 6.552ZM52.077 130h9.72v-2.214h-5.004l2.43-2.376c1.494-1.44 2.484-2.844 2.484-4.554 0-2.322-1.62-3.906-4.464-3.906-2.88 0-4.68 1.62-4.824 4.59h2.646c.198-1.692.918-2.358 2.052-2.358 1.116 0 1.71.684 1.71 1.746 0 1.17-.792 2.304-2.034 3.618l-4.716 4.986V130Zm12.598 0h2.97l4.608-12.546v-.324h-9.324v2.358h5.67L64.675 130Zm13.828-2.088c-1.8 0-2.754-1.35-2.754-4.05v-.612c0-2.664.918-4.05 2.718-4.05 1.782 0 2.682 1.458 2.682 4.05v.576c0 2.7-.828 4.086-2.646 4.086Zm-.072 2.286c3.474 0 5.616-2.448 5.616-6.39v-.594c0-3.996-2.286-6.264-5.598-6.264s-5.616 2.358-5.616 6.318v.612c0 3.942 2.178 6.318 5.598 6.318Zm9.61-.198h2.916v-12.87H88.4l-2.97 2.106v2.484l2.61-1.71V130Zm10.326.198c2.862 0 5.022-1.386 5.022-3.906 0-1.53-.846-2.646-2.358-3.168 1.134-.504 1.872-1.386 1.872-2.682 0-2.196-2.052-3.492-4.518-3.492-2.412 0-4.554 1.278-4.554 3.51 0 1.296.702 2.196 1.872 2.682-1.476.522-2.376 1.656-2.376 3.222 0 2.52 2.196 3.834 5.04 3.834Zm0-2.124c-1.188 0-2.142-.702-2.142-1.98s.972-1.98 2.16-1.98c1.206 0 2.124.702 2.124 1.962 0 1.278-.918 1.998-2.142 1.998Zm.036-5.742c-1.008 0-1.854-.63-1.854-1.674s.81-1.674 1.836-1.674 1.818.666 1.818 1.656c0 1.062-.756 1.692-1.8 1.692Z"
  })));
};
/* harmony default export */ var BadgeIso27018 = (SvgBadgeIso27018);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/SecurityHighlight/assets/BadgeAicpaSoc.svg
var BadgeAicpaSoc_path, BadgeAicpaSoc_path2, _path3, _path4, _defs;
function BadgeAicpaSoc_extends() { BadgeAicpaSoc_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return BadgeAicpaSoc_extends.apply(this, arguments); }

var SvgBadgeAicpaSoc = function SvgBadgeAicpaSoc(props) {
  return /*#__PURE__*/react.createElement("svg", BadgeAicpaSoc_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 96,
    fill: "none"
  }, props), BadgeAicpaSoc_path || (BadgeAicpaSoc_path = /*#__PURE__*/react.createElement("path", {
    fill: "url(#BadgeAicpaSoc_svg__a)",
    d: "M48.873 96c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48Z"
  })), BadgeAicpaSoc_path2 || (BadgeAicpaSoc_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "url(#BadgeAicpaSoc_svg__b)",
    d: "M48.874 85.247c20.57 0 37.244-16.675 37.244-37.245 0-20.57-16.675-37.244-37.244-37.244-20.57 0-37.245 16.675-37.245 37.245 0 20.57 16.675 37.244 37.245 37.244Z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fill: "#606B85",
    d: "M89.53 85.82v.33h-.633v1.678h-.385v-1.677h-.633v-.33h1.65Zm2.172 2.009-.082-1.183c0-.165 0-.358-.028-.55h-.027c-.055.165-.11.412-.165.605l-.358 1.1h-.412l-.358-1.155a5.76 5.76 0 0 0-.138-.578h-.027c0 .193 0 .385-.028.55l-.082 1.183h-.385l.137-2.008h.606l.357.99c.055.165.083.303.138.495.055-.192.082-.357.137-.495l.358-.99h.578l.165 2.008h-.386v.028Z"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M19.468 79.687c.137-.137.192-.275.165-.44-.028-.165-.11-.412-.303-.715a2.68 2.68 0 0 1-.33-.743c-.055-.275.027-.495.192-.687.166-.193.386-.248.66-.22.276.027.523.165.743.385.165.165.275.33.33.495.055.192.083.358.055.55a.867.867 0 0 1-.247.468l-.193-.193a.745.745 0 0 0 .22-.55.857.857 0 0 0-.302-.578c-.193-.165-.358-.275-.55-.302-.193-.028-.358.027-.468.165a.507.507 0 0 0-.138.44c.028.165.11.385.276.66.165.275.275.495.302.66.055.165.055.33.028.468a.784.784 0 0 1-.22.385c-.193.192-.413.275-.66.248-.248-.028-.523-.166-.77-.413-.166-.165-.303-.33-.386-.55a1.001 1.001 0 0 1-.082-.55.782.782 0 0 1 .247-.468l.193.192a.655.655 0 0 0-.193.578c.028.22.165.44.358.633a.99.99 0 0 0 .577.302c.193-.027.358-.082.495-.22ZM22.493 81.42a1.834 1.834 0 0 1-.633.523c-.22.11-.468.137-.688.11a1.23 1.23 0 0 1-.632-.303 1.134 1.134 0 0 1-.44-.935c0-.385.137-.743.44-1.1l.22-.276c.192-.22.412-.412.632-.522.22-.11.468-.138.688-.11.22.027.44.137.633.302.192.165.33.358.412.578.083.22.083.44 0 .688-.055.247-.192.467-.385.715l-.247.33Zm.027-.468c.248-.302.385-.605.385-.907 0-.303-.11-.55-.357-.743-.248-.193-.495-.275-.798-.22-.275.055-.55.247-.825.55l-.22.275c-.248.303-.385.605-.385.908 0 .302.11.55.357.743.248.192.495.275.798.22.302-.056.55-.248.825-.55l.22-.276ZM24.75 83.623c-.247.275-.495.413-.77.44a1.176 1.176 0 0 1-.853-.275 1.25 1.25 0 0 1-.412-.522c-.083-.22-.11-.44-.055-.688.055-.248.165-.495.33-.715l.247-.358c.165-.247.358-.412.578-.55a.992.992 0 0 1 .66-.165c.22 0 .44.083.66.248.303.22.468.44.523.715.055.275 0 .55-.165.853l-.22-.165c.275-.496.192-.908-.248-1.238-.247-.165-.495-.22-.77-.138-.275.083-.523.275-.77.605l-.248.33c-.22.303-.33.606-.33.908 0 .303.138.523.385.688.248.165.468.247.66.22.193-.028.413-.138.605-.358l.193.165ZM25.932 85.604l1.155-1.926-.358-.22.11-.192.358.22.165-.248c.138-.22.275-.358.468-.413.192-.055.357-.027.577.11.083.055.165.11.22.193l-.137.192c-.055-.054-.11-.11-.193-.164-.137-.083-.247-.11-.385-.056a.586.586 0 0 0-.302.276l-.165.275.495.302-.11.193-.495-.303-1.156 1.926-.247-.165ZM27.665 85.162c.11-.22.248-.385.44-.495a.84.84 0 0 1 .55-.192c.193 0 .386.027.578.137.303.165.468.385.55.688.083.302.028.605-.165.963l-.027.055a1.11 1.11 0 0 1-.44.495.84.84 0 0 1-.55.192c-.193 0-.386-.027-.578-.137-.275-.165-.468-.385-.55-.688-.083-.303-.028-.605.165-.963l.027-.055Zm.193.193c-.138.247-.193.522-.138.742.055.248.165.413.385.523.22.11.44.138.66.028.22-.11.413-.275.55-.55l.028-.055c.083-.166.138-.33.165-.496 0-.165-.027-.33-.082-.467a.764.764 0 0 0-.33-.33c-.22-.11-.44-.138-.66-.028-.22.083-.413.275-.55.55l-.028.083ZM31.598 86.072l-.165-.082a.637.637 0 0 0-.44-.055c-.138.027-.275.137-.413.275l-.743 1.54-.247-.11 1.073-2.228.247.11-.165.358c.248-.193.523-.248.825-.11.083.027.11.055.138.11l-.11.192ZM34.349 88.736c.055-.165.055-.33-.028-.467-.082-.138-.275-.33-.55-.55-.275-.22-.495-.413-.605-.578a.676.676 0 0 1-.083-.715c.083-.248.275-.385.523-.468.248-.082.523-.055.825.055.22.083.385.193.495.33.138.138.22.303.248.468a.862.862 0 0 1-.055.522l-.275-.11c.082-.22.082-.412-.028-.605-.082-.192-.275-.33-.522-.412-.248-.083-.44-.11-.633-.055a.485.485 0 0 0-.358.33.481.481 0 0 0 .055.467c.11.165.248.303.496.496.247.192.44.33.55.467.11.138.192.275.22.413a.62.62 0 0 1-.055.44.694.694 0 0 1-.523.468c-.248.082-.55.055-.853-.083-.22-.082-.412-.193-.55-.358a.939.939 0 0 1-.302-.495.973.973 0 0 1 .055-.55l.275.11a.67.67 0 0 0 .055.605c.11.193.302.33.577.44.248.083.468.11.633.055.193.055.33-.055.413-.22ZM35.835 90.14a.99.99 0 0 1-.495-.33 1.023 1.023 0 0 1-.247-.523 1.272 1.272 0 0 1 .055-.633l.027-.082c.083-.22.165-.413.33-.578a.939.939 0 0 1 .495-.302.935.935 0 0 1 .55 0c.276.082.496.247.578.495.11.247.11.55 0 .88l-.055.138-1.678-.523-.027.055c-.083.275-.083.523.027.743.11.22.275.385.495.44a.63.63 0 0 0 .385.027c.11-.027.248-.082.358-.165l.138.165c-.248.248-.55.303-.936.193Zm.66-2.256a.846.846 0 0 0-.577.055 1.11 1.11 0 0 0-.44.495l1.43.44v-.027c.055-.22.055-.44-.027-.605a.56.56 0 0 0-.386-.358ZM39.026 88.626a.39.39 0 0 0-.165-.055.677.677 0 0 0-.468.028c-.137.054-.248.164-.358.33l-.44 1.65-.275-.055.633-2.393.247.055-.082.385c.22-.248.468-.33.798-.248a.448.448 0 0 1 .165.083l-.055.22ZM39.851 90.719l1.156-1.898.275.055-1.403 2.228-.22-.055-.413-2.614.275.056.33 2.228ZM41.611 91.436l-.275-.055.413-2.448.275.055-.413 2.448Zm.22-3.191c0-.055.028-.083.083-.11.027-.028.082-.028.137-.028.055 0 .11.028.138.083.027.028.027.082.027.138 0 .054-.027.082-.082.11-.055.027-.083.027-.138.027a.151.151 0 0 1-.137-.083c-.028-.027-.028-.082-.028-.137ZM43.372 91.516c.192.028.358 0 .495-.11.138-.11.22-.22.248-.385l.247.028a.734.734 0 0 1-.192.385.933.933 0 0 1-.386.247c-.165.055-.302.055-.467.055-.33-.027-.55-.192-.715-.44-.165-.247-.22-.55-.165-.935v-.082c.027-.248.11-.44.22-.633a.92.92 0 0 1 .412-.385c.165-.083.358-.11.578-.083a.897.897 0 0 1 .633.33c.165.193.22.413.192.66l-.247-.027c0-.193-.028-.358-.138-.495a.712.712 0 0 0-.468-.248c-.247-.027-.44.028-.605.193-.165.165-.247.413-.302.715v.083c-.028.302 0 .577.11.77.11.192.302.33.55.357ZM45.903 91.982a1.196 1.196 0 0 1-.55-.192c-.166-.11-.276-.276-.358-.468a1.614 1.614 0 0 1-.11-.633v-.11c.027-.247.082-.44.192-.632a.992.992 0 0 1 .413-.413c.165-.11.357-.138.55-.138.303.028.523.138.688.358.165.22.22.495.192.853v.165l-1.76-.11v.055c-.028.275.055.523.192.715.138.193.33.303.578.33.138 0 .275 0 .385-.055.11-.055.22-.11.33-.247l.165.137c-.22.303-.522.413-.907.385Zm.11-2.338a.628.628 0 0 0-.523.193 1.16 1.16 0 0 0-.303.577l1.486.11v-.027c0-.248-.055-.44-.165-.605a.854.854 0 0 0-.495-.248ZM51.184 90.525c0 .302-.028.577-.138.797-.11.22-.248.413-.44.55-.193.138-.413.193-.688.193-.385 0-.715-.11-.963-.385-.247-.275-.385-.633-.385-1.128v-.33c0-.302.028-.578.138-.798.11-.247.247-.412.44-.55.192-.137.413-.192.688-.192.247 0 .495.055.687.165.193.11.358.302.468.522.11.22.165.496.193.77v.386Zm-.303-.358c0-.413-.11-.715-.303-.935a.942.942 0 0 0-.742-.33c-.303 0-.55.137-.743.357-.165.22-.275.55-.248.963v.358c0 .385.11.715.303.935.192.22.44.33.743.33.33 0 .577-.138.742-.358.165-.22.248-.55.248-.962v-.358ZM52.944 89.619h-.192c-.165 0-.303.082-.413.165a.748.748 0 0 0-.22.44l.138 1.705-.275.028-.193-2.476.275-.027.028.385c.11-.303.33-.468.66-.495.082 0 .137 0 .192.027v.248ZM53.33 90.552c-.055-.386 0-.688.137-.936.138-.247.358-.385.66-.412.33-.055.605.055.826.302l-.028-.357.248-.028.302 2.393c.028.303-.027.578-.165.798-.165.22-.385.33-.688.358-.164.027-.33 0-.495-.055a1.034 1.034 0 0 1-.412-.248l.137-.193c.22.22.468.303.743.275.22-.027.385-.11.495-.275.11-.137.165-.357.138-.577l-.028-.303c-.137.275-.385.413-.715.468a.857.857 0 0 1-.715-.248c-.193-.192-.33-.495-.385-.88l-.055-.082Zm.302.027c.028.303.138.55.275.715.138.165.33.22.578.193.33-.055.55-.22.66-.55l-.137-1.128a.947.947 0 0 0-.33-.33c-.138-.083-.275-.083-.44-.055a.632.632 0 0 0-.496.33c-.11.192-.165.467-.11.825ZM57.84 91.133a.93.93 0 0 1-.11-.33 1.234 1.234 0 0 1-.302.357.905.905 0 0 1-.44.193.758.758 0 0 1-.605-.083c-.165-.11-.275-.247-.303-.44-.055-.247.028-.44.193-.605.165-.165.44-.302.77-.357l.495-.083-.055-.275a.535.535 0 0 0-.248-.385.604.604 0 0 0-.495-.055.747.747 0 0 0-.44.22.408.408 0 0 0-.11.385l-.275.055a.693.693 0 0 1 .165-.55c.165-.165.358-.275.633-.33.275-.055.495-.028.688.082.192.11.302.275.357.523l.22 1.155c.055.248.11.413.165.523v.027l-.302-.027Zm-.88-.028a.926.926 0 0 0 .468-.22c.138-.11.193-.247.248-.412l-.11-.523-.468.083c-.275.055-.468.137-.605.275-.138.137-.193.275-.165.44.027.137.11.247.22.302.11.055.247.083.412.055ZM58.527 88.438l.11.413c.055-.165.137-.303.248-.413a.757.757 0 0 1 .412-.22c.248-.055.468-.055.633.082.165.11.275.303.357.606l.413 1.567-.275.056-.413-1.568c-.055-.22-.137-.358-.247-.44-.11-.083-.275-.11-.468-.055-.165.055-.302.137-.385.275a.768.768 0 0 0-.165.495l.413 1.65-.275.055-.606-2.393.248-.11ZM60.536 87.168c-.028-.055 0-.083 0-.138.027-.055.055-.082.11-.082.055-.028.11 0 .137 0 .028 0 .083.055.083.11.027.055 0 .082 0 .137-.028.055-.055.083-.11.083-.055.027-.11 0-.138 0-.055-.028-.082-.055-.082-.11Zm1.21 2.97-.275.083-.715-2.365.275-.083.715 2.366ZM62.654 89.62l1.513-.524.083.22-1.843.633-.055-.192.743-2.421-1.376.468-.082-.22 1.705-.578.055.192-.742 2.421ZM66.258 88.489c-.055-.055-.11-.165-.193-.303-.027.165-.11.275-.22.413-.11.11-.247.22-.385.275-.22.082-.412.11-.605.027a.545.545 0 0 1-.385-.385c-.082-.22-.082-.44.055-.633.138-.192.358-.385.688-.522l.467-.193-.11-.247a.519.519 0 0 0-.302-.33c-.138-.055-.303-.028-.495.027-.165.083-.303.165-.385.303a.391.391 0 0 0-.028.385l-.248.11c-.082-.193-.055-.385.056-.578.11-.192.302-.357.55-.467.247-.11.495-.138.687-.055.193.055.358.22.44.44l.44 1.073c.083.22.193.385.276.467v.028l-.303.165Zm-.88.137c.165-.082.302-.165.412-.302a.675.675 0 0 0 .165-.44l-.22-.496-.44.193c-.247.11-.44.248-.522.385-.083.138-.138.303-.055.468.055.137.137.22.275.247.082.028.247 0 .385-.055ZM66.258 85.078l.275.578.468-.22.082.192-.467.22.687 1.486c.055.137.138.22.193.247.055.028.165.028.275-.027.055-.028.11-.055.193-.11l.11.192a.96.96 0 0 1-.248.165.502.502 0 0 1-.44.028c-.11-.055-.22-.193-.33-.385l-.688-1.486-.412.193-.083-.193.413-.192-.275-.578.247-.11ZM67.166 84.527c-.027-.055-.027-.082-.027-.138 0-.054.055-.082.11-.11.055-.027.11-.027.137-.027a.379.379 0 0 1 .11.083c.028.027.028.082 0 .137a.215.215 0 0 1-.11.11c-.055.028-.11.028-.137.028-.028 0-.055-.028-.083-.083ZM68.9 87.25l-.247.138-1.128-2.2.247-.138 1.128 2.2ZM68.87 85.824c-.11-.22-.192-.412-.192-.632 0-.22.027-.413.11-.578.082-.165.247-.303.412-.413a.994.994 0 0 1 .88-.082c.303.11.523.33.716.66l.027.055c.11.22.193.413.193.633 0 .22-.028.412-.11.577-.083.165-.248.303-.413.413a.945.945 0 0 1-.852.082c-.303-.11-.523-.33-.716-.66l-.055-.055Zm.275-.055c.138.248.33.44.55.523.22.082.44.082.66-.055.22-.11.33-.303.386-.55.055-.248-.028-.495-.165-.77l-.028-.056a1.295 1.295 0 0 0-.357-.412.674.674 0 0 0-.44-.165.807.807 0 0 0-.44.11c-.22.11-.33.302-.386.55-.027.248.028.495.165.77l.055.055ZM70.878 83.265l.248.358c0-.165.027-.33.11-.496.082-.137.192-.247.33-.357.22-.138.44-.193.605-.138.192.055.357.22.523.468l.88 1.375-.22.138-.88-1.375c-.11-.193-.248-.303-.386-.33a.622.622 0 0 0-.467.11.712.712 0 0 0-.303.385.847.847 0 0 0 0 .522l.936 1.43-.22.138-1.349-2.063.193-.165ZM75.087 82.605a.392.392 0 0 0-.33-.165c-.138 0-.303.055-.523.138a5.06 5.06 0 0 1-.495.165c-.138.027-.248.027-.358-.028a.439.439 0 0 1-.248-.193.589.589 0 0 1-.082-.522c.055-.193.192-.385.385-.523.22-.165.44-.247.66-.22.22 0 .385.11.523.275l-.22.165c-.083-.11-.193-.165-.358-.192-.165 0-.302.055-.467.165-.138.11-.248.22-.275.357-.028.138-.028.248.054.358.083.11.166.137.276.137.11 0 .275-.055.522-.137.22-.11.413-.165.55-.165.138-.028.248 0 .358.027.11.028.192.11.275.22.11.165.165.358.083.55a1.266 1.266 0 0 1-.413.55c-.22.166-.468.248-.688.248-.22 0-.412-.082-.522-.275l.22-.165c.11.11.22.193.385.193s.302-.055.467-.193a.787.787 0 0 0 .303-.385c0-.137 0-.275-.082-.385ZM78.69 81.254l-.165.165-2.613-2.943.165-.165 2.613 2.943ZM81.139 76.716a.36.36 0 0 0-.358-.11c-.137.028-.302.11-.55.248-.247.137-.44.247-.632.302-.358.083-.633.028-.853-.165a.912.912 0 0 1-.275-.688 1.28 1.28 0 0 1 .385-.797c.165-.165.33-.303.522-.358.193-.055.385-.11.55-.055.193.028.358.11.496.248l-.385.412a.66.66 0 0 0-.413-.165.67.67 0 0 0-.413.248.764.764 0 0 0-.22.412c0 .138.028.248.138.358.082.083.192.11.33.083.138-.028.33-.11.55-.248.22-.138.44-.22.605-.275a1.01 1.01 0 0 1 .495-.028c.165.028.275.11.413.22.193.193.303.413.275.688-.027.275-.165.523-.413.798a1.818 1.818 0 0 1-.55.385c-.192.082-.412.11-.577.11a1.023 1.023 0 0 1-.523-.248l.385-.412c.138.137.303.192.44.165a.697.697 0 0 0 .468-.303c.137-.137.22-.275.22-.412.027-.22-.028-.33-.11-.413ZM83.257 75.592c-.22.275-.495.412-.798.468-.302.027-.605-.083-.907-.303l-.055-.055c-.193-.165-.33-.33-.413-.523-.083-.192-.138-.385-.11-.605.027-.192.11-.385.248-.55.22-.275.467-.385.742-.413.275 0 .578.11.88.358l.166.138-1.018 1.265c.165.11.33.165.495.137a.652.652 0 0 0 .413-.247.681.681 0 0 0 .137-.688l.413-.055c.055.165.055.358.027.523-.027.165-.082.412-.22.55Zm-1.705-1.266a.493.493 0 0 0-.11.386c.027.137.11.275.22.412l.66-.825-.028-.028c-.165-.11-.302-.165-.412-.137-.11 0-.22.055-.33.192ZM83.339 72.154a.73.73 0 0 0-.138.165c-.137.193-.165.413-.055.578l1.376.99-.33.44-2.008-1.457.302-.44.22.164c-.082-.247-.082-.44.055-.632.055-.055.083-.11.138-.138l.44.33ZM85.1 71.796l-1.182-1.403.302-.467 1.596 2.063-.276.412-2.53-.632.33-.468 1.76.495ZM83.834 69.288a.318.318 0 0 1-.138-.192c-.027-.083 0-.165.055-.248a.37.37 0 0 1 .193-.165.293.293 0 0 1 .22.028c.082.055.11.11.138.165.027.082 0 .165-.056.247a.37.37 0 0 1-.192.165c-.083.055-.165.055-.22 0Zm2.97 1.1-.274.468-2.118-1.265.275-.468 2.118 1.266ZM87.3 68.713c.056-.11.083-.247.056-.357-.028-.11-.083-.22-.193-.275l.248-.468a.7.7 0 0 1 .302.33c.055.138.11.303.11.468 0 .165-.055.33-.137.495-.166.302-.386.495-.688.55-.303.083-.605 0-.963-.165l-.055-.028c-.33-.192-.55-.412-.66-.687-.11-.275-.083-.578.082-.88.138-.248.33-.44.578-.523a.999.999 0 0 1 .743.055l-.248.468c-.137-.055-.247-.083-.385-.028-.137.028-.22.11-.275.248a.558.558 0 0 0-.027.467c.055.138.22.275.44.413l.082.055c.248.138.44.192.605.165.165-.055.303-.138.385-.303ZM88.868 66.538c-.137.33-.357.522-.66.632-.302.11-.605.083-.935-.082l-.055-.028a1.703 1.703 0 0 1-.55-.412 1.107 1.107 0 0 1-.248-.55.878.878 0 0 1 .11-.578c.138-.303.358-.495.633-.578.275-.082.577-.027.935.138l.193.082-.688 1.458a.696.696 0 0 0 .523.028.603.603 0 0 0 .357-.33.685.685 0 0 0-.027-.688l.385-.138c.082.165.137.33.137.495a.774.774 0 0 1-.11.55Zm-1.925-.826a.537.537 0 0 0 0 .413c.055.138.165.248.33.358l.44-.963-.028-.028c-.165-.055-.33-.082-.44-.055a.438.438 0 0 0-.302.275ZM89.364 60.873c.302.11.55.248.743.44.192.193.33.413.385.633.055.248.027.495-.055.743-.083.248-.22.468-.44.605-.22.138-.413.248-.688.275-.275.028-.55 0-.853-.11l-.165-.055c-.302-.11-.55-.247-.742-.44a1.355 1.355 0 0 1-.386-.66 1.374 1.374 0 0 1 .055-.743c.083-.247.22-.467.413-.605.193-.165.413-.248.688-.275.275-.027.55.028.852.11l.193.083Zm-.358.496c-.357-.11-.632-.165-.88-.083-.22.055-.385.22-.468.468a.707.707 0 0 0 .083.66c.138.192.385.358.715.468l.193.055c.357.11.632.137.88.082.248-.055.385-.22.468-.468.082-.247.055-.467-.083-.66-.137-.192-.385-.357-.743-.467l-.165-.055ZM89.501 59.003a1.889 1.889 0 0 0-.082.22c-.083.248-.028.44.137.578l1.623.467-.165.523-2.366-.688.138-.522.275.055a.671.671 0 0 1-.165-.633c.028-.082.055-.137.082-.193l.523.193ZM90.272 58.948c-.386-.083-.66-.248-.826-.468a.79.79 0 0 1-.165-.77.803.803 0 0 1 .44-.578l-.247-.082.11-.495 2.338.55c.303.082.55.22.688.468.137.247.165.522.082.852-.055.165-.11.33-.22.495a.788.788 0 0 1-.385.303l-.275-.33a.744.744 0 0 0 .44-.55.541.541 0 0 0-.055-.468.487.487 0 0 0-.385-.248l-.165-.027c.137.192.165.413.11.688a.793.793 0 0 1-.495.605c-.275.137-.605.165-.99.055Zm.165-.523c.247.055.44.055.605 0a.448.448 0 0 0 .302-.357c.055-.22 0-.413-.165-.55l-1.073-.248c-.22.055-.33.192-.385.412-.055.165 0 .33.11.468.138.11.33.22.606.275ZM92.361 54.986c-.055.027-.137.027-.247.027.165.193.22.44.165.688-.055.248-.138.44-.303.55a.674.674 0 0 1-.55.138c-.248-.055-.44-.165-.55-.386-.11-.22-.138-.495-.055-.852l.055-.33-.165-.028a.45.45 0 0 0-.33.055c-.083.055-.138.165-.165.303-.028.137 0 .22.027.33.055.082.11.137.22.165l-.082.55a.658.658 0 0 1-.358-.192c-.11-.11-.165-.248-.22-.413a.847.847 0 0 1 0-.523c.055-.275.165-.495.33-.632.165-.138.385-.193.66-.166l1.1.193c.22.028.413.028.55 0h.028l-.11.523Zm-.495.522c.028-.11 0-.22-.028-.33a.4.4 0 0 0-.164-.247l-.468-.083-.055.303c-.028.192-.028.357.027.467.055.11.138.193.275.193a.32.32 0 0 0 .275-.055c.083-.028.11-.138.138-.248ZM90.133 53.032l.275.028a.914.914 0 0 1-.248-.743c.056-.523.386-.743.963-.688l1.623.165-.055.55-1.595-.165c-.165-.027-.275 0-.358.055-.082.055-.137.166-.137.33a.5.5 0 0 0 .247.523l1.76.193-.054.55-2.448-.275.027-.523ZM89.693 50.918a.312.312 0 0 1-.22-.083c-.055-.055-.082-.137-.082-.247 0-.11.027-.165.11-.22a.312.312 0 0 1 .22-.083c.082 0 .165.028.192.083.028.055.083.137.055.247 0 .11-.027.165-.11.22 0 .083-.082.083-.165.083Zm3.136-.385-.027.55-2.476-.165.027-.55 2.476.165ZM92.444 49.238l.027-1.32h.44l-.055 2.008H92.5l-1.623-1.293-.028 1.238h-.44l.028-1.925h.357l1.65 1.292ZM92.856 45.908a.93.93 0 0 1-.22.082.822.822 0 0 1 .303.633c0 .247-.055.44-.192.605a.639.639 0 0 1-.523.247c-.275 0-.468-.082-.605-.275-.138-.192-.22-.467-.248-.825v-.33h-.165c-.138 0-.22.055-.303.11-.082.083-.11.193-.11.33 0 .138.028.22.11.303.083.082.138.11.248.11l.028.55a.63.63 0 0 1-.386-.11.992.992 0 0 1-.302-.358 1.116 1.116 0 0 1-.11-.522c0-.303.055-.523.192-.688a.747.747 0 0 1 .606-.275l1.127-.027c.22 0 .386-.056.523-.11h.028v.55Zm-.357.605c0-.11-.028-.22-.083-.303a.836.836 0 0 0-.22-.22l-.467.028v.302c0 .193.055.358.137.468.083.11.165.137.303.137.11 0 .192-.055.247-.11.055-.055.083-.165.083-.302ZM89.666 44.317l.605-.055-.027-.44.412-.028.028.44 1.375-.11c.083 0 .165-.028.193-.083.027-.027.055-.11.055-.192 0-.055-.028-.138-.028-.193l.44-.027c.055.11.083.248.083.358.027.412-.193.66-.66.687l-1.403.11.027.413-.412.027-.028-.412-.605.055-.055-.55ZM89.557 43.492c-.083 0-.165 0-.22-.055-.055-.055-.11-.11-.11-.22s0-.193.055-.248c.055-.055.11-.11.192-.11.083 0 .165 0 .22.055.055.055.11.11.11.22s0 .193-.055.248c-.055.055-.11.11-.192.11Zm3.025-.935.055.55-2.448.275-.055-.55 2.448-.275ZM91.261 42.14c-.248.027-.468.027-.66-.028-.193-.056-.385-.166-.495-.33a1.009 1.009 0 0 1-.248-.578c-.055-.33 0-.605.193-.853.192-.248.44-.385.797-.468l.138-.027c.248-.028.468-.028.66.027.193.055.385.165.495.33.138.166.22.358.248.578.055.358 0 .633-.22.88-.193.248-.495.413-.908.468Zm-.027-.551a1.12 1.12 0 0 0 .577-.248c.138-.137.165-.275.138-.467-.028-.193-.138-.33-.275-.385-.166-.083-.386-.083-.66-.055a.934.934 0 0 0-.55.247c-.138.138-.166.275-.138.468.027.192.137.302.275.385.11.082.33.11.633.055ZM89.501 39.143l.275-.083a.971.971 0 0 1-.495-.632c-.11-.495.11-.825.688-.963l1.595-.358.138.55-1.568.358a.539.539 0 0 0-.33.165c-.083.083-.083.193-.028.358a.53.53 0 0 0 .413.412l1.706-.385.137.55-2.42.55-.11-.522ZM90.353 35.29c-.083.027-.165.082-.193.192-.027.083-.027.248-.027.44.027.193 0 .358 0 .495-.055.303-.193.495-.44.55a.63.63 0 0 1-.578-.11 1.091 1.091 0 0 1-.412-.605c-.083-.275-.083-.522 0-.742a.644.644 0 0 1 .467-.413l.165.523c-.11.027-.165.082-.22.192a.35.35 0 0 0 0 .33.57.57 0 0 0 .165.275c.083.055.165.083.248.055a.248.248 0 0 0 .165-.165c.027-.082.027-.247.027-.467-.027-.22 0-.413.028-.55a.918.918 0 0 1 .137-.33.82.82 0 0 1 .303-.193.685.685 0 0 1 .605.11c.193.137.33.357.413.633.055.192.082.385.055.55-.028.165-.083.33-.193.44-.11.11-.22.192-.358.247l-.164-.522c.11-.055.22-.11.247-.22.028-.11.055-.248 0-.386a.625.625 0 0 0-.165-.302c-.11-.028-.192-.055-.275-.028ZM31.544 37.435h-6.767l-1.54 4.18h-1.321l5.639-14.908h1.21l5.64 14.909h-1.321l-1.54-4.181Zm-6.382-1.073h5.996l-2.998-8.115-2.998 8.115ZM37.925 41.616H36.66V26.707h1.266v14.909ZM52.312 36.968c-.165 1.568-.743 2.778-1.678 3.604-.935.825-2.228 1.237-3.796 1.237-1.1 0-2.09-.275-2.943-.825-.853-.55-1.513-1.348-1.98-2.338-.468-1.018-.688-2.173-.716-3.466v-1.925c0-1.32.22-2.503.688-3.521.468-1.018 1.128-1.816 2.008-2.366.88-.55 1.87-.825 2.998-.825 1.596 0 2.861.44 3.796 1.293.935.853 1.458 2.063 1.623 3.576h-1.265c-.303-2.53-1.678-3.796-4.126-3.796-1.348 0-2.42.495-3.246 1.513-.798 1.017-1.21 2.42-1.21 4.18v1.816c0 1.733.385 3.108 1.182 4.126.77 1.018 1.843 1.54 3.164 1.54 1.32 0 2.31-.302 2.97-.935.66-.632 1.073-1.568 1.238-2.833h1.293v-.055ZM56.437 35.537v6.079h-1.265V26.707h5.089c1.54 0 2.778.385 3.686 1.183.907.797 1.347 1.87 1.347 3.273s-.44 2.476-1.292 3.246c-.853.77-2.118 1.155-3.741 1.155h-3.824v-.027Zm0-1.045h3.824c1.21 0 2.145-.303 2.805-.88.633-.578.963-1.404.963-2.421 0-1.046-.33-1.843-.963-2.476-.632-.605-1.54-.935-2.723-.935h-3.906v6.712ZM74.538 37.435H67.77l-1.54 4.18h-1.32l5.638-14.908h1.21l5.64 14.909h-1.32l-1.541-4.181Zm-6.382-1.073h5.997l-2.999-8.115-2.998 8.115ZM40.072 62.195c0-.825-.303-1.485-.88-1.953-.578-.495-1.651-.935-3.191-1.375-1.54-.44-2.669-.908-3.384-1.43-1.017-.716-1.513-1.679-1.513-2.861 0-1.128.468-2.063 1.403-2.779.936-.715 2.146-1.072 3.604-1.072.99 0 1.87.192 2.668.577.77.385 1.375.908 1.815 1.596.44.687.633 1.458.633 2.283h-1.265c0-1.018-.358-1.843-1.046-2.448-.687-.605-1.622-.936-2.805-.936-1.128 0-2.036.248-2.724.77-.687.523-1.017 1.183-1.017 2.009 0 .77.302 1.375.907 1.87.606.468 1.568.908 2.916 1.265 1.348.358 2.366.743 3.053 1.128.688.385 1.21.853 1.568 1.403.358.55.523 1.183.523 1.926 0 1.182-.468 2.118-1.403 2.833-.935.715-2.173 1.073-3.713 1.073a7.608 7.608 0 0 1-2.889-.55c-.88-.386-1.54-.908-2.008-1.568-.467-.688-.687-1.458-.687-2.339h1.265c0 1.046.385 1.87 1.183 2.504.798.605 1.843.907 3.136.907 1.155 0 2.09-.247 2.805-.77.688-.55 1.046-1.238 1.046-2.063ZM54.87 59.197c0 1.375-.248 2.585-.715 3.603-.468 1.046-1.156 1.843-2.036 2.393-.88.55-1.898.853-3.053.853-1.733 0-3.136-.633-4.209-1.87-1.073-1.238-1.595-2.916-1.595-5.034v-1.54c0-1.348.247-2.559.715-3.604.495-1.045 1.155-1.843 2.035-2.42.88-.55 1.898-.853 3.054-.853 1.155 0 2.173.275 3.026.825.88.55 1.567 1.348 2.035 2.338.468 1.018.715 2.173.743 3.52v1.789Zm-1.266-1.623c0-1.788-.412-3.19-1.21-4.209-.825-1.018-1.925-1.513-3.328-1.513-1.376 0-2.503.523-3.301 1.54-.825 1.019-1.238 2.449-1.238 4.292v1.568c0 1.76.413 3.163 1.238 4.208.825 1.046 1.925 1.54 3.328 1.54 1.43 0 2.53-.522 3.329-1.54.797-1.017 1.21-2.448 1.21-4.263v-1.623h-.028ZM68.375 61.203c-.165 1.567-.743 2.778-1.678 3.603-.936.825-2.228 1.238-3.796 1.238-1.1 0-2.09-.275-2.944-.825-.852-.55-1.513-1.348-1.98-2.338-.468-1.018-.688-2.174-.715-3.466v-1.926c0-1.32.22-2.503.687-3.52.468-1.019 1.128-1.816 2.008-2.366.88-.55 1.87-.826 2.999-.826 1.595 0 2.86.44 3.796 1.293.935.853 1.458 2.063 1.623 3.576h-1.266c-.302-2.53-1.678-3.796-4.126-3.796-1.348 0-2.42.495-3.246 1.513-.797 1.018-1.21 2.42-1.21 4.181v1.816c0 1.733.385 3.108 1.183 4.126.77 1.017 1.843 1.54 3.163 1.54 1.32 0 2.31-.302 2.97-.935.661-.633 1.074-1.568 1.239-2.833h1.293v-.056ZM78.305 46.6H21.448c-.082 0-.137-.056-.137-.138 0-.083.055-.138.137-.138h56.857c.083 0 .138.055.138.138 0 .082-.055.137-.138.137ZM30.8 74.488a1.459 1.459 0 0 1-.082-.303c-.22.248-.495.358-.826.358-.275 0-.522-.083-.687-.248a.743.743 0 0 1-.275-.605c0-.302.11-.522.33-.687.22-.165.55-.248.962-.248h.468v-.22a.56.56 0 0 0-.165-.413c-.11-.11-.247-.165-.467-.165a.76.76 0 0 0-.44.138.392.392 0 0 0-.166.33h-.495a.66.66 0 0 1 .165-.413c.11-.137.248-.247.413-.33.165-.082.357-.11.578-.11.33 0 .577.083.77.248.192.165.275.385.302.688v1.32c0 .275.028.468.11.632v.056H30.8v-.028Zm-.825-.385a.808.808 0 0 0 .44-.11.797.797 0 0 0 .303-.303v-.577h-.385c-.606 0-.908.165-.908.522 0 .165.055.275.165.358.082.082.22.11.385.11ZM31.846 70.857a.25.25 0 0 1 .082-.192c.055-.056.11-.083.22-.083.083 0 .165.028.22.083a.25.25 0 0 1 .083.192.25.25 0 0 1-.083.193c-.055.055-.11.082-.22.082a.312.312 0 0 1-.22-.082.25.25 0 0 1-.082-.193Zm.522 3.631h-.495V71.6h.495v2.888ZM34.183 74.13c.165 0 .33-.055.468-.165a.62.62 0 0 0 .22-.385h.468c0 .165-.055.33-.165.468-.11.137-.248.275-.413.358a1.252 1.252 0 0 1-.55.137c-.385 0-.715-.138-.935-.385a1.677 1.677 0 0 1-.358-1.073v-.082c0-.275.055-.523.165-.743.11-.22.248-.385.44-.495.193-.11.413-.193.688-.193.33 0 .578.11.797.303.22.192.33.44.33.743h-.467a.747.747 0 0 0-.22-.468c-.138-.11-.275-.193-.468-.193-.247 0-.44.083-.577.275-.138.193-.193.44-.193.77v.083c0 .33.055.578.193.77.11.193.33.275.577.275ZM38.173 73.09c0 .44-.11.797-.303 1.044-.192.276-.467.413-.825.413-.358 0-.633-.11-.825-.33v1.375h-.495v-3.988h.44l.027.33c.193-.248.468-.385.825-.385.358 0 .633.137.826.385.192.248.302.633.302 1.1v.055h.028Zm-.495-.056c0-.33-.083-.577-.22-.77-.138-.192-.33-.275-.578-.275a.711.711 0 0 0-.66.385v1.375c.137.276.385.386.687.386.248 0 .413-.083.55-.276.138-.192.22-.467.22-.825ZM40.43 74.488a1.459 1.459 0 0 1-.083-.303c-.22.248-.496.358-.826.358-.275 0-.522-.083-.687-.248a.743.743 0 0 1-.275-.605c0-.302.11-.522.33-.687.22-.165.55-.248.962-.248h.468v-.22a.56.56 0 0 0-.165-.413c-.11-.11-.248-.165-.468-.165a.76.76 0 0 0-.44.138.392.392 0 0 0-.165.33h-.495a.66.66 0 0 1 .165-.413c.11-.137.248-.247.413-.33.165-.082.357-.11.577-.11.33 0 .578.083.77.248.193.165.276.385.303.688v1.32c0 .275.028.468.11.632v.056h-.495v-.028Zm-.826-.385a.808.808 0 0 0 .44-.11.797.797 0 0 0 .303-.303v-.577h-.386c-.605 0-.907.165-.907.522 0 .165.055.275.165.358.11.082.247.11.385.11ZM41.5 74.242c0-.083.028-.165.083-.22a.313.313 0 0 1 .22-.083c.082 0 .165.028.22.083a.312.312 0 0 1 .082.22.25.25 0 0 1-.082.193.312.312 0 0 1-.22.082.313.313 0 0 1-.22-.082.25.25 0 0 1-.083-.193ZM42.656 73.034c0-.275.055-.522.165-.77.11-.248.275-.385.468-.523.192-.11.413-.192.688-.192.385 0 .715.137.962.412.248.276.358.633.358 1.073v.028c0 .275-.055.522-.165.742-.11.22-.248.385-.468.523-.192.138-.44.193-.687.193-.385 0-.716-.138-.936-.413-.247-.275-.357-.633-.357-1.073h-.028Zm.495.055c0 .33.083.578.22.77a.73.73 0 0 0 .606.303c.247 0 .44-.11.605-.303.165-.192.22-.467.22-.825 0-.302-.083-.577-.22-.77a.73.73 0 0 0-.605-.303c-.248 0-.44.11-.578.303a1.4 1.4 0 0 0-.248.825ZM47.14 72.072c-.083 0-.166-.028-.248-.028-.33 0-.55.138-.66.413v2.035h-.496v-2.888h.468v.33c.165-.248.385-.385.688-.385.082 0 .165 0 .22.027v.496h.027ZM47.277 73.03c0-.44.11-.798.303-1.073.22-.275.495-.385.825-.385.358 0 .633.138.825.385l.028-.33h.44v2.806c0 .385-.11.66-.33.88-.22.22-.523.33-.88.33a1.5 1.5 0 0 1-.605-.137 1.246 1.246 0 0 1-.468-.358l.247-.302c.22.247.468.385.77.385.248 0 .413-.055.55-.193.138-.137.193-.33.193-.578v-.247c-.192.22-.467.33-.797.33s-.605-.138-.826-.413c-.165-.275-.275-.632-.275-1.1Zm.495.055c0 .33.056.578.193.77.138.193.33.275.55.275.303 0 .55-.137.688-.412v-1.32c-.138-.276-.385-.413-.688-.413-.247 0-.412.082-.55.275-.11.192-.193.468-.193.825ZM50.413 74.82H50l1.623-4.209h.413l-1.623 4.209ZM54.098 73.722c0-.138-.055-.248-.137-.303-.11-.082-.275-.137-.523-.192a2.617 2.617 0 0 1-.605-.193 1.1 1.1 0 0 1-.33-.275.553.553 0 0 1-.11-.357c0-.248.11-.44.303-.606.192-.165.467-.247.77-.247.33 0 .577.082.797.247a.823.823 0 0 1 .303.633h-.495a.484.484 0 0 0-.165-.358c-.11-.11-.248-.137-.44-.137-.193 0-.33.027-.413.11a.38.38 0 0 0-.165.303c0 .11.055.22.138.275.082.055.275.11.522.165.248.055.44.11.605.192.165.083.275.165.33.275.056.11.11.248.11.385a.73.73 0 0 1-.302.606c-.193.165-.468.22-.798.22-.22 0-.44-.028-.605-.11a1.22 1.22 0 0 1-.413-.33c-.11-.138-.137-.303-.137-.468h.495a.48.48 0 0 0 .193.385c.11.083.275.138.495.138.192 0 .33-.028.44-.11.11-.083.137-.11.137-.248ZM54.978 73.034c0-.275.055-.522.166-.77.11-.248.275-.385.467-.523.193-.11.413-.192.688-.192.385 0 .715.137.963.412.247.276.357.633.357 1.073v.028c0 .275-.055.522-.165.742-.11.22-.247.385-.468.523-.192.138-.44.193-.687.193-.385 0-.715-.138-.935-.413-.248-.275-.358-.633-.358-1.073h-.028Zm.496.055c0 .33.082.578.22.77a.73.73 0 0 0 .605.303c.247 0 .44-.11.605-.303.165-.192.22-.467.22-.825 0-.302-.082-.577-.22-.77a.73.73 0 0 0-.605-.303c-.248 0-.44.11-.578.303a1.4 1.4 0 0 0-.247.825ZM59.215 74.13c.165 0 .33-.055.467-.165a.62.62 0 0 0 .22-.385h.468c0 .165-.055.33-.165.468-.11.137-.248.275-.413.358a1.253 1.253 0 0 1-.55.137c-.385 0-.715-.138-.935-.385a1.677 1.677 0 0 1-.358-1.073v-.082c0-.275.055-.523.165-.743.11-.22.248-.385.44-.495.193-.11.413-.193.688-.193.33 0 .578.11.798.303.22.192.33.44.33.743h-.468a.747.747 0 0 0-.22-.468c-.137-.11-.275-.193-.468-.193-.247 0-.44.083-.577.275-.138.193-.193.44-.193.77v.083c0 .33.055.578.193.77.137.193.33.275.578.275ZM62.818 73.197h.55v.413h-.55v.907h-.495v-.907h-1.76v-.303l1.732-2.696h.523v2.586Zm-1.705 0h1.21v-1.898l-.055.11-1.155 1.788ZM65.378 73.722c0-.138-.055-.248-.138-.303-.11-.082-.275-.137-.522-.192a2.617 2.617 0 0 1-.606-.193 1.1 1.1 0 0 1-.33-.275.553.553 0 0 1-.11-.357c0-.248.11-.44.303-.606.192-.165.467-.247.77-.247.33 0 .578.082.798.247a.823.823 0 0 1 .302.633h-.495a.484.484 0 0 0-.165-.358c-.11-.11-.248-.137-.44-.137-.193 0-.33.027-.413.11a.38.38 0 0 0-.165.303c0 .11.055.22.138.275.082.055.275.11.522.165.248.055.44.11.606.192.165.083.275.165.33.275.055.11.11.248.11.385a.73.73 0 0 1-.303.606c-.192.165-.467.22-.797.22-.22 0-.44-.028-.606-.11a1.22 1.22 0 0 1-.412-.33c-.11-.138-.138-.303-.138-.468h.495a.48.48 0 0 0 .193.385c.11.11.275.138.495.138.193 0 .33-.028.44-.11.11-.083.138-.11.138-.248ZM66.23 73.034c0-.275.055-.522.165-.77.11-.22.276-.385.468-.523.193-.11.413-.192.688-.192.385 0 .715.137.963.412.247.276.357.633.357 1.073v.028c0 .275-.055.522-.165.742-.11.22-.248.385-.468.523-.192.138-.44.193-.687.193-.385 0-.715-.138-.935-.413-.248-.275-.358-.633-.358-1.073h-.027Zm.496.055c0 .33.082.578.22.77a.73.73 0 0 0 .605.303c.247 0 .44-.11.605-.303.137-.192.22-.467.22-.825 0-.302-.083-.577-.22-.77a.73.73 0 0 0-.605-.303c-.248 0-.44.11-.578.303a1.4 1.4 0 0 0-.247.825Z"
  })), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("linearGradient", {
    id: "BadgeAicpaSoc_svg__a",
    x1: 96.873,
    x2: 0.873,
    y1: 48,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#606B85"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#CACDD8"
  })), /*#__PURE__*/react.createElement("linearGradient", {
    id: "BadgeAicpaSoc_svg__b",
    x1: 86.474,
    x2: 11.274,
    y1: 48.002,
    y2: 48.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("stop", {
    stopColor: "#AEB2C1"
  }), /*#__PURE__*/react.createElement("stop", {
    offset: 1,
    stopColor: "#606B85"
  })))));
};
/* harmony default export */ var BadgeAicpaSoc = (SvgBadgeAicpaSoc);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/SecurityHighlight/assets/BadgeCsa.svg
var _g, BadgeCsa_defs;
function BadgeCsa_extends() { BadgeCsa_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return BadgeCsa_extends.apply(this, arguments); }

var SvgBadgeCsa = function SvgBadgeCsa(props) {
  return /*#__PURE__*/react.createElement("svg", BadgeCsa_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 64,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    fill: "#606B85",
    clipPath: "url(#BadgeCsa_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M162.491 58.75a2.357 2.357 0 0 1-1.784-.785l.484-.453c.362.393.816.664 1.39.664.756 0 1.27-.362 1.33-.965.061-.513-.211-.815-1.179-1.177-1.148-.422-1.511-.815-1.39-1.63.121-.905.907-1.418 1.965-1.418.755 0 1.209.212 1.632.604l-.453.483c-.363-.332-.726-.513-1.27-.513-.756 0-1.149.392-1.209.814-.061.453.121.724 1.179 1.117 1.179.452 1.511.875 1.39 1.69-.121.905-.906 1.569-2.085 1.569ZM169.896 58.66l.544-3.803.091-.603c-.091.211-.302.634-.453.935l-1.996 3.591-.967-3.59a7.924 7.924 0 0 1-.212-.936l-.09.603-.544 3.802h-.605l.786-5.582h.695l.847 3.35c.09.331.211.844.242 1.086.12-.242.362-.755.544-1.087l1.813-3.349h.666l-.786 5.582h-.575ZM77.334 6.337c-.786-.694-1.541-1.087-2.75-1.087-1.905 0-3.598 1.51-4.021 4.195-.393 2.625.604 4.315 2.78 4.315 1.18 0 2.026-.423 2.994-1.147l.876.966c-1.148.905-2.448 1.478-4.141 1.478-2.66 0-4.837-1.78-4.263-5.522.605-3.953 3.568-5.642 6.107-5.642 1.663 0 2.811.543 3.658 1.267l-1.24 1.177ZM80.176 14.876 82.352.845 84.226 0 81.93 14.876h-1.753ZM89.939 15.087c-2.962 0-4.958-1.93-4.383-5.582.574-3.62 3.234-5.582 6.197-5.582 2.962 0 4.957 1.87 4.383 5.522-.544 3.62-3.235 5.642-6.197 5.642Zm1.572-9.836c-2.116 0-3.749 1.418-4.172 4.224-.423 2.806.756 4.285 2.872 4.285 2.116 0 3.779-1.479 4.202-4.285.423-2.806-.786-4.224-2.902-4.224ZM105.568 14.876l.212-1.297c-.847.905-2.086 1.538-3.598 1.538-2.57 0-4.05-1.327-3.597-4.405l.998-6.518h1.753l-.967 6.277c-.363 2.293.423 3.349 2.357 3.349 1.693 0 3.175-.996 3.537-3.35l.968-6.276h1.753l-1.663 10.712h-1.753v-.03ZM118.022 14.876l.212-1.297c-.998.814-2.267 1.538-3.9 1.538-2.448 0-4.111-1.629-3.537-5.4.575-3.803 2.933-5.764 5.472-5.764 1.542 0 2.479.573 3.204 1.418l.696-4.496 1.874-.845-2.298 14.876h-1.723v-.03Zm1.24-7.996c-.544-.905-1.602-1.6-3.053-1.6-2.026 0-3.265 1.54-3.688 4.406-.424 2.686.513 4.104 2.448 4.104 1.3 0 2.449-.604 3.477-1.54l.816-5.37ZM88.095 63.76l.211-1.298C87.34 63.276 86.01 64 84.256 64c-1.905 0-3.779-.844-3.356-3.44.363-2.413 2.781-3.44 5.2-3.44 1.24 0 2.267.272 2.932.604l.181-1.267c.242-1.6-.483-2.354-2.267-2.354-1.27 0-2.358.302-3.446.815l-.454-1.237c1.15-.513 2.63-.845 4.202-.845 2.63 0 4.112.965 3.749 3.47l-1.149 7.453h-1.753Zm.756-4.799c-.726-.392-1.542-.603-3.054-.603-1.783 0-2.962.754-3.174 2.112-.242 1.6.635 2.293 2.116 2.293 1.572 0 2.872-.724 3.749-1.599l.363-2.203ZM93.688 63.759l2.176-14.001 1.874-.875-2.297 14.876h-1.754ZM99.492 63.759l2.146-14.001 1.875-.875-2.298 14.876h-1.723ZM105.266 63.758l1.662-10.712h1.754l-1.663 10.712h-1.753Zm2.841-12.613c-.725 0-1.209-.483-1.118-1.086.09-.604.725-1.086 1.451-1.086.635 0 1.118.482 1.028 1.086-.061.603-.696 1.086-1.361 1.086ZM117.901 63.76l.212-1.298c-.997.814-2.297 1.538-4.051 1.538-1.904 0-3.778-.844-3.355-3.44.363-2.413 2.781-3.44 5.199-3.44 1.24 0 2.268.272 2.933.604l.181-1.267c.242-1.6-.484-2.354-2.267-2.354-1.27 0-2.358.302-3.446.815l-.454-1.237c1.149-.513 2.63-.845 4.202-.845 2.63 0 4.111.965 3.749 3.47l-1.149 7.453h-1.754Zm.756-4.799c-.725-.392-1.541-.603-3.053-.603-1.784 0-2.962.754-3.174 2.112-.242 1.6.635 2.293 2.116 2.293 1.572 0 2.872-.724 3.748-1.599l.363-2.203ZM131.021 63.759l.967-6.276c.363-2.294-.423-3.35-2.357-3.35-1.693 0-3.175.996-3.537 3.35l-.968 6.276h-1.753l1.663-10.712h1.753l-.212 1.298c.847-.906 2.086-1.54 3.598-1.54 2.569 0 4.05 1.328 3.597 4.406l-.998 6.518h-1.753v.03ZM145.23 55.25c-.786-.694-1.542-1.087-2.751-1.087-1.905 0-3.598 1.51-4.021 4.195-.393 2.625.605 4.315 2.751 4.315 1.179 0 2.026-.423 2.993-1.147l.877.966c-1.149.905-2.449 1.478-4.142 1.478-2.66 0-4.837-1.81-4.262-5.522.604-3.953 3.567-5.642 6.106-5.642 1.663 0 2.811.543 3.658 1.267l-1.209 1.177ZM157.503 58.931h-8.132c-.181 2.293.816 3.742 2.811 3.742 1.421 0 2.298-.362 3.537-1.026l.635 1.116c-1.602.815-2.721 1.238-4.565 1.238-2.237 0-4.715-1.419-4.081-5.643.514-3.41 2.993-5.522 5.895-5.522 3.174 0 4.565 2.203 4.081 5.25-.03.393-.091.604-.181.845Zm-4.111-4.767c-1.814 0-3.235 1.146-3.809 3.53h6.559c.182-2.082-.604-3.53-2.75-3.53ZM101.638 38.2c-1.663 0-3.054-.543-4.081-1.357l1.179-1.117c.846.755 1.934 1.177 3.143 1.177 1.663 0 2.57-.603 2.721-1.66.121-.875-.514-1.357-2.539-2.172-2.298-.905-3.205-1.569-2.963-3.289.242-1.63 2.026-2.746 4.232-2.746 1.663 0 2.903.483 3.719 1.147l-1.149 1.116c-.846-.664-1.602-.965-2.902-.965-1.27 0-2.116.543-2.237 1.327-.151.905.423 1.268 2.358 2.082 2.146.906 3.416 1.51 3.114 3.44-.273 2.112-2.479 3.018-4.595 3.018ZM118.807 33.161h-8.131c-.182 2.294.816 3.742 2.811 3.742 1.421 0 2.297-.362 3.537-1.026l.635 1.087c-1.602.814-2.721 1.237-4.565 1.237-2.237 0-4.716-1.419-4.081-5.643.544-3.41 2.993-5.522 5.895-5.522 3.174 0 4.564 2.203 4.081 5.25-.03.393-.091.634-.182.875Zm-4.111-4.767c-1.814 0-3.234 1.147-3.809 3.53h6.56c.181-2.082-.604-3.53-2.751-3.53ZM130.054 29.45c-.786-.694-1.542-1.086-2.751-1.086-1.904 0-3.597 1.508-4.02 4.194-.393 2.625.604 4.315 2.781 4.315 1.179 0 2.025-.422 2.992-1.147l.907.966c-1.148.905-2.448 1.478-4.141 1.478-2.66 0-4.837-1.81-4.263-5.522.605-3.952 3.568-5.642 6.107-5.642 1.662 0 2.811.543 3.658 1.267l-1.27 1.177ZM139.879 37.99l.211-1.298c-.846.905-2.055 1.539-3.597 1.539-2.57 0-4.051-1.328-3.597-4.406l.997-6.517h1.753l-.967 6.276c-.363 2.293.423 3.35 2.358 3.35 1.693 0 3.174-.996 3.537-3.35l.967-6.276h1.754l-1.663 10.712h-1.753v-.03ZM153.058 28.877c-.453-.241-.967-.423-1.783-.423-1.693 0-2.842 1.207-3.144 3.26l-.968 6.276h-1.753l1.663-10.712h1.753l-.212 1.327c.696-.845 1.965-1.539 3.265-1.539.907 0 1.482.09 1.874.272l-.695 1.539ZM154.963 37.99l1.663-10.712h1.753l-1.663 10.712h-1.753Zm2.841-12.644c-.725 0-1.209-.482-1.118-1.086.091-.603.725-1.086 1.451-1.086.665 0 1.118.483 1.028 1.086-.091.604-.695 1.086-1.361 1.086ZM164.304 28.575l-1.088 6.97c-.152.966.09 1.298 1.027 1.298.696 0 1.179-.09 1.754-.302l-.333 1.328c-.725.241-1.39.362-2.297.362-1.512 0-2.207-.664-1.935-2.414l1.119-7.212h-1.512l.212-1.297h1.511l.514-3.29 1.874-.844-.635 4.164h3.023l-.211 1.297h-3.023v-.06ZM171.559 41.761h-1.723l2.267-3.892-2.72-10.592h1.844l1.783 7.785.242 1.087.575-1.087 4.201-7.785h1.844l-8.313 14.484ZM9.77 33.736c-.09.422-.15.844-.242 1.297-.665 4.617.333 8.268 4.112 8.268 2.75 0 4.141-1.418 6.287-4.255l6.863 3.742c-2.721 3.953-6.802 7.785-14.299 7.785-9.401 0-13.422-6.639-12.122-15.54.06-.453.12-.875.212-1.297h9.19Zm-8.192-3.38c2.63-6.88 8.525-10.863 15.538-10.863 7.77 0 10.369 3.199 11.699 8.872l-8.374 2.957c-.725-2.807-1.541-4.557-4.413-4.557-2.298 0-3.99 1.388-5.109 3.591h-9.34ZM52.123 33.705c2.418 1.6 3.325 3.772 2.841 7.091-1.027 6.88-6.892 9.717-14.48 9.717-5.108 0-9.794-1.6-12.787-3.652l5.2-6.547c2.086 1.508 5.864 3.017 8.797 3.017 3.113 0 4.171-.513 4.383-1.931.151-1.117-.877-1.81-4.958-2.746-4.988-1.147-8.101-2.384-9.371-4.949h20.375Zm-20.98-3.349c.03-.423.06-.875.121-1.358.847-5.673 6.228-9.505 13.876-9.505 5.38 0 9.069 1.237 12.091 3.5l-5.199 6.548c-2.54-1.81-5.17-2.836-8.373-2.836-2.63 0-3.356.784-3.537 1.84-.121.815.393 1.298 2.146 1.841l-11.125-.03ZM63.277 30.355l4.928-10.41h7.618l1.874 10.41M67.026 38.14h4.504l-.484-4.435h7.255l2.933 16.355h-8.132l-.695-5.28h-8.162l-2.268 5.28h-8.07l7.768-16.355H68.9"
  }))), BadgeCsa_defs || (BadgeCsa_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "BadgeCsa_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M.127 0h179.745v64H.127z"
  })))));
};
/* harmony default export */ var BadgeCsa = (SvgBadgeCsa);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/components/SecurityHighlight/SecurityHighlight.tsx


function SecurityHighlight_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var SecurityHighlight_copy = {
  overline: "Security Highlight",
  heading: "Industry-leading Security & Compliance",
  description: "Our commitment to security and compliance includes a comprehensive suite of certifications and attestations so you can trust that your data stays secure and compliant."
};
var SecurityHighlight_link = {
  text: "Learn more",
  url: "/security/"
};

var SecurityHighlight = function SecurityHighlight() {
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SecurityHighlight_Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "centered",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Copy */.CK, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          centered: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Overline */.Lh, {
            children: SecurityHighlight_copy.overline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
            children: SecurityHighlight_copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: SecurityHighlight_copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: (0,getAbsoluteUrl/* default */.Z)(SecurityHighlight_link.url, pageConfig),
            target: "_blank",
            children: SecurityHighlight_link.text
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionContents, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SecurityHighlight_StyledColumnTrack, {
          center: true,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFigureBase, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeIso27001, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFigureBase, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeIso27017, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFigureBase, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeIso27018, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFigureBase, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeCsa, {})
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFigureBase, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgeAicpaSoc, {})
          })]
        })
      })]
    })
  });
};

var SecurityHighlight_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1m8ddrh3"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.down("md");
}, "{max-width:720px;margin:auto;}" + ( true ? "" : 0));

var StyledSectionContents = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Contents */.AU,  true ? {
  target: "e1m8ddrh2"
} : 0)( true ? {
  name: "1w7bo27",
  styles: "max-width:600px;margin:0 auto"
} : 0);

var SecurityHighlight_StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "e1m8ddrh1"
} : 0)("row-gap:50px;column-gap:80px;grid-template-columns:repeat(2, 1fr);", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("sm");
}, "{grid-template-columns:repeat(6, 1fr);grid-template-rows:50% 50%;}" + ( true ? "" : 0));

var StyledFigureBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Figure/* default */.ZP,  true ? {
  target: "e1m8ddrh0"
} : 0)("justify-content:center;&:nth-of-type(4){order:1;grid-column:span 2;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{grid-column:span 2;&:nth-of-type(4){order:initial;grid-column:2/span 2;}}" + ( true ? "" : 0));

/* harmony default export */ var SecurityHighlight_SecurityHighlight = (SecurityHighlight);
// EXTERNAL MODULE: ./src/views/Industry/FinancialServicesPage/assets/OgSegmentIndustryFinancialServices.png
var OgSegmentIndustryFinancialServices = __webpack_require__(15250);
var OgSegmentIndustryFinancialServices_default = /*#__PURE__*/__webpack_require__.n(OgSegmentIndustryFinancialServices);
;// CONCATENATED MODULE: ./src/views/Industry/FinancialServicesPage/IndustryFinancialServices.tsx




















var IndustryFinancialServicesView = function IndustryFinancialServicesView() {
  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: "twilioLight",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(layout/* default */.Z, {
      pageTitle: "Industry: Financial Services | Twilio Segment",
      pageDescription: "Twilio Segment for Financial Services",
      pageOG: (OgSegmentIndustryFinancialServices_default()),
      themeColor: theme.palette.neutrals.white[100],
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navigation/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("main", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Hero_Hero, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel_LogoCarousel, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MainContent, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_CentralizeAndSimplify_CentralizeAndSimplify, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MakeInformedDecisions_MakeInformedDecisions, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PersonalizeEveryInteraction_PersonalizeEveryInteraction, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_PropCardCta_PropCardCta, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SecurityHighlight_SecurityHighlight, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_UseSegment_UseSegment, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Testimonials_Testimonials, {})]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GettingStarted["default"], {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer/* default */.Z, {})]
    })
  });
};

var MainContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eihasll0"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

/* harmony default export */ var IndustryFinancialServices = (IndustryFinancialServicesView);
;// CONCATENATED MODULE: ./src/pages/industry/financial-services.tsx



var FinancialServices = function FinancialServices() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IndustryFinancialServices, {});
};

/* harmony default export */ var financial_services = (FinancialServices);

/***/ }),

/***/ 96856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useLocation_useLocation; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/api/staticSiteBackend/client.ts + 2 modules
var client = __webpack_require__(39896);
;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/location.ts



var fetchLocation = function fetchLocation(client, signal) {
  return client.get("/location/", {
    signal: signal,
    headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
  });
};

var fetchLocationCode = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(client, signal) {
    var code;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/location/countryCode/", {
              signal: signal,
              headers: [["X-Backend-Api", String("KiBZKjNMR0k4ZX1pcGZjIG9fRnh3V14m")]]
            });

          case 2:
            code = _context.sent;
            return _context.abrupt("return", code.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchLocationCode(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();


;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/useLocation.ts





/**
 * A hook that provides the country code of the user's location.
 * @returns The country code of the user's location.
 */

var useLocation = function useLocation() {
  var _useState = (0,react.useState)(""),
      code = _useState[0],
      setCode = _useState[1];

  var fetchData = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(signal) {
      var response;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchLocationCode((0,client/* createClient */.e)(), signal);

            case 3:
              response = _context.sent;
              setCode(response.toLowerCase());
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              setCode("us");

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  (0,react.useEffect)(function () {
    var controller = new AbortController();
    fetchData(controller.signal);
    return function () {
      controller.abort();
    };
  }, [fetchData]);
  return code;
};

/* harmony default export */ var useLocation_useLocation = (useLocation);
;// CONCATENATED MODULE: ../../libs/api/utils/useLocation/index.ts


/***/ }),

/***/ 805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ DemoProvider; },
/* harmony export */   "d": function() { return /* binding */ DemoContext; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52903);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var DemoContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
  completedFormData: undefined,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCompletedFormData: function setCompletedFormData() {}
});
var DemoProvider = function DemoProvider(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
    completedFormData: undefined,
    setCompletedFormData: function setCompletedFormData(value) {
      return setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          completedFormData: value
        });
      });
    }
  }),
      state = _useState[0],
      setState = _useState[1];

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(DemoContext.Provider, {
    value: state,
    children: children
  });
};

/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ }),

/***/ 31714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MI": function() { return /* binding */ SignupButton; },
/* harmony export */   "_f": function() { return /* binding */ SignupButtonText; }
/* harmony export */ });
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82269);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33445);
/* harmony import */ var _segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74870);
/* harmony import */ var _segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17782);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);


var _excluded = ["color", "variant", "size", "expanded", "children", "additionalParams", "linkToApp"],
    _excluded2 = ["appearance", "children", "additionalParams", "linkToApp"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var useTransformUrl = function useTransformUrl(customQuery, linkToApp) {
  var _usePageConfig = (0,_segment_contexts_page__WEBPACK_IMPORTED_MODULE_4__/* .usePageConfig */ .Gm)(),
      queryParamsFromCookie = _usePageConfig.queryParamsFromCookie,
      appUrl = _usePageConfig.appUrl;

  var hostUrl = linkToApp ? appUrl : "https://segment.com";
  var queryString = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    var query = new URLSearchParams(queryParamsFromCookie);

    for (var qs in customQuery) {
      query.append(qs, customQuery[qs]);
    }

    return query.toString() ? "?".concat(query.toString()) : "";
  }, [queryParamsFromCookie, customQuery]);
  return "".concat(hostUrl, "/signup/").concat(queryString);
};

var SignupButton = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "primary" : _ref$color,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "filled" : _ref$variant,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      expanded = _ref.expanded,
      children = _ref.children,
      additionalParams = _ref.additionalParams,
      _ref$linkToApp = _ref.linkToApp,
      linkToApp = _ref$linkToApp === void 0 ? false : _ref$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref, _excluded);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    variant: variant,
    size: size,
    color: color,
    expanded: expanded,
    tag: "a",
    href: url,
    ref: ref
  }, rest), {}, {
    children: children
  }));
});
var SignupButtonText = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var externalAppearance = _ref2.appearance,
      children = _ref2.children,
      additionalParams = _ref2.additionalParams,
      _ref2$linkToApp = _ref2.linkToApp,
      linkToApp = _ref2$linkToApp === void 0 ? false : _ref2$linkToApp,
      rest = (0,_workdir_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded2);

  var url = useTransformUrl(additionalParams, linkToApp);
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_segment_matcha_components_ButtonText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({
    ref: ref,
    href: url,
    appearance: externalAppearance
  }, rest), {}, {
    children: children
  }));
});
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (SignupButton)));

/***/ }),

/***/ 77931:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__.MI; },
/* harmony export */   "_": function() { return /* reexport safe */ _SignupButton__WEBPACK_IMPORTED_MODULE_0__._f; }
/* harmony export */ });
/* harmony import */ var _SignupButton__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31714);


/***/ }),

/***/ 4009:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _Footer__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34810);


/***/ }),

/***/ 77840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* binding */ FormSubmitMessage; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/data.tsx
var data = {
  success: {
    demo: {
      description: "Thank you for submitting your request for a demo! Answer 4 more questions to help us pinpoint exactly what your team needs to get started with Segment."
    }
  },
  error: {
    demo: {
      description: "We are really sorry. There was an error processing your submission. Try reloading your browser, and submitting again."
    }
  }
};
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq3"
} : 0)("padding:32px;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";border-radius:8px;text-align:left;" + ( true ? "" : 0));
var Header = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e10kq2lq2"
} : 0)( true ? {
  name: "9qwgfz",
  styles: "display:grid;grid-auto-flow:column;grid-template-columns:max-content 1fr;align-items:center;gap:8px"
} : 0);
var StyledDescription = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq1"
} : 0)( true ? {
  name: "172op4w",
  styles: "margin-top:0;margin-bottom:0"
} : 0);
var StyledTypography = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "e10kq2lq0"
} : 0)( true ? {
  name: "7ut0hf",
  styles: "margin:0;margin-bottom:16px"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx


var _excluded = ["form", "status", "heading", "description", "tokens", "appearance"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}








var BaseFormSubmitMessage = function BaseFormSubmitMessage(_ref) {
  var form = _ref.form,
      status = _ref.status,
      heading = _ref.heading,
      description = _ref.description,
      tokens = _ref.tokens,
      externalAppearance = _ref.appearance,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var localData = form && data[status][form];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread(_objectSpread({}, tokens.wrapper), rest), {}, {
      children: [heading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTypography, {
          variant: "h4",
          tag: "p",
          tokens: tokens.header,
          children: heading
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDescription, {
        variant: "pMedium",
        tokens: tokens.description,
        children: description || (localData === null || localData === void 0 ? void 0 : localData.description)
      })]
    }))
  });
};

var FormSubmitMessage = (0,useDesignTokens/* withDesignTokens */.Y)(BaseFormSubmitMessage, function () {
  return {};
}, {
  dark: function dark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[300]
      }
    };
  },
  light: function light(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.brand.darkAcai[300]
      },
      description: {
        color: theme.palette.brand.darkAcai[500]
      }
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.twilio.gray[100]
      }
    };
  },
  twilioDark: function twilioDark(theme) {
    return {
      wrapper: {
        borderColor: theme.palette.twilio.gray[30]
      },
      description: {
        color: theme.palette.neutrals.white[100]
      }
    };
  }
});
/* harmony default export */ var FormSubmitMessage_FormSubmitMessage = ((/* unused pure expression or super */ null && (FormSubmitMessage)));

/***/ }),

/***/ 98960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ DemoForm; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-element-6a883da9.browser.esm.js + 1 modules
var emotion_element_6a883da9_browser_esm = __webpack_require__(28543);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitMessage/FormSubmitMessage.tsx + 2 modules
var FormSubmitMessage = __webpack_require__(77840);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/api/utils/useLocation/index.ts + 2 modules
var useLocation = __webpack_require__(96856);
// EXTERNAL MODULE: ../../libs/utils/useMatchMedia/index.ts + 1 modules
var useMatchMedia = __webpack_require__(61093);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/sharedEmail.ts
var sharedEmail = __webpack_require__(13206);
// EXTERNAL MODULE: ../../libs/utils/regexes/email.ts
var email = __webpack_require__(36219);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/utils/regexes/lastName.ts
var lastName = __webpack_require__(51895);
;// CONCATENATED MODULE: ../../libs/utils/regexes/forbiddenEmail.ts
var customDomainList = ["@gmail.com", "@yahoo.com", "@hotmail.com", "@aol.com", "@hotmail.co.uk", "@hotmail.fr", "@msn.com", "@yahoo.fr", "@wanadoo.fr", "@orange.fr", "@comcast.net", "@yahoo.co.uk", "@yahoo.com.br", "@yahoo.co.in", "@live.com", "@rediffmail.com", "@free.fr", "@gmx.de", "@web.de", "@yandex.ru", "@ymail.com", "@libero.it", "@outlook.com", "@uol.com.br", "@bol.com.br", "@mail.ru", "@cox.net", "@hotmail.it", "@sbcglobal.net", "@sfr.fr", "@live.fr", "@verizon.net", "@live.co.uk", "@googlemail.com", "@yahoo.es", "@ig.com.br", "@live.nl", "@bigpond.com", "@terra.com.br", "@yahoo.it", "@neuf.fr", "@yahoo.de", "@alice.it", "@rocketmail.com", "@att.net", "@laposte.net", "@facebook.com", "@bellsouth.net", "@yahoo.in", "@hotmail.es", "@charter.net", "@yahoo.ca", "@yahoo.com.au", "@rambler.ru", "@hotmail.de", "@tiscali.it", "@shaw.ca", "@yahoo.co.jp", "@sky.com", "@earthlink.net", "@optonline.net", "@freenet.de", "@t-online.de", "@aliceadsl.fr", "@virgilio.it", "@home.nl", "@qq.com", "@telenet.be", "@me.com", "@yahoo.com.ar", "@tiscali.co.uk", "@yahoo.com.mx", "@voila.fr", "@gmx.net", "@mail.com", "@planet.nl", "@tin.it", "@live.it", "@ntlworld.com", "@arcor.de", "@yahoo.co.id", "@frontiernet.net", "@hetnet.nl", "@live.com.au", "@yahoo.com.sg", "@zonnet.nl", "@club-internet.fr", "@juno.com", "@optusnet.com.au", "@blueyonder.co.uk", "@bluewin.ch", "@skynet.be", "@sympatico.ca", "@windstream.net", "@mac.com", "@centurytel.net", "@chello.nl", "@live.ca", "@aim.com", "@bigpond.net.au", "@email.com", "@gmail", "@yahoo", "@hotmail", "@outlook", "@protonmail", "@gwk.com", "@free.", "@tutanota", "@gmx", "@mail2world", "@icloud", "@segment.com", "@.om", "@163.com", "@qq", "@gmai.com", "@yaoo.com", "@company.com", "@gail.com", "@abc.com", "@domain.com", "@gma.com", "@gnail.com", "@li.com", "@yah.com", "@5euros.com", "@business.com", "@emil.com", "@gaylord.info", "@gimal.com", "@gml.com", "@info.com", "@mailinator.com", "@w.com", "@yhoo.com", "@yo.com", "@0546876.com", "@10.com", "@101.gmail.com", "@11.com", "@12356gmail.com", "@123yahoo.com", "@175gmali.com", "@1servicesteamfrazier.com", "@2gmail.com", "@2ncad.com", "@365gmial.com", "@37.com", "@5024gmail.com", "@70gmail.com", "@72gmail.co.com", "@81gmail.com", "@8543g.mail.com", "@9085.gmail.com", "@9784.com", "@asdf.com", "@asdfas222334.com", "@asdsad.com", "@fuckyou.com", "@g.com", "@g.email", "@gamill.com", "@gimel.com", "@gl.com", "@gmaiil.com", "@gmaik.com", "@gmail-elif.com", "@gmail.com.pk", "@gmail.com120194", "@gmail.com4", "@gmaile.com", "@gmaill.com", "@gmaiol.com", "@gmaqil.com", "@gmaul.com", "@gmeel.come", "@gmil.comraj", "@gmsil.com", "@gmw.ere", "@gnail.con", "@haha.com", "@hahaha.com", "@il.co", "@il.com", "@test.cc", "@us.army.mil", "@ya.com", "@yaahoo.com", "@yahoo.coin", "@yho.com", "@yohoo.com", "@.aim", "@zoho", "@protonmail.com", "@mailinator", "@boutique1.com", "@bugfoo.com", "@duiter.com", "@fectode.com", "@gmial.com", "@jewelry.com", "@jims.net", "@jthoven.com", "@lolcorporate.com", "@naver.com", "@restaurant.com", "@stayclearbeauty.com", "@tem.com.my", "@thegymgroup.com", "@Marco.com"]; // Escape the dots in the domains, as they have a special meaning in regex

var escapedDomains = customDomainList.map(function (domain) {
  return domain.replace(/\./g, "\\.");
}); // Create the regex pattern using negative lookahead

var REGEX_PATTERN = "^(?!.*(".concat(escapedDomains.join("|"), ")).*$");
var forbiddenEmailRegex = new RegExp(REGEX_PATTERN, "i"); // Use the 'i' flag for case-insensitive matching

/* harmony default export */ var forbiddenEmail = (forbiddenEmailRegex);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx + 2 modules
var ProgressiveProfileForm = __webpack_require__(6612);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.views.tsx

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc2"
} : 0)( true ? "" : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc1"
} : 0)( true ? "" : 0);
var DisclaimerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1dszmc0"
} : 0)( true ? "" : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/DemoForm.tsx


var _excluded = ["appearance", "className", "before", "after", "isProgressive", "isLeadEnrichmentFormEnabled", "overrideConsent", "customFormIdentifier", "customTrackingType", "successMessageAppearance", "onEmailCompleted", "buttonText", "customDisclaimer", "driftCampaignId", "successMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable react-hooks/exhaustive-deps */





























var MOBILE_OFFSET = -150;
var DESKTOP_OFFSET = -350;
var FORM_ID = "demo-form"; // Set up demo form props since we define some of these props here in the template

var DemoForm = function DemoForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$isProgressive = _ref.isProgressive,
      isProgressive = _ref$isProgressive === void 0 ? false : _ref$isProgressive,
      _ref$isLeadEnrichment = _ref.isLeadEnrichmentFormEnabled,
      isLeadEnrichmentFormEnabled = _ref$isLeadEnrichment === void 0 ? true : _ref$isLeadEnrichment,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      customTrackingType = _ref.customTrackingType,
      successMessageAppearance = _ref.successMessageAppearance,
      onEmailCompleted = _ref.onEmailCompleted,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? "Get a demo" : _ref$buttonText,
      customDisclaimer = _ref.customDisclaimer,
      driftCampaignId = _ref.driftCampaignId,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var theme = (0,emotion_element_6a883da9_browser_esm.u)();
  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var countryCode = (0,useLocation/* default */.Z)(); // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality

  var _useState = (0,react.useState)(false),
      emailCompleted = _useState[0],
      setEmailCompleted = _useState[1];

  var _useState2 = (0,react.useState)(undefined),
      intPhoneErrorCode = _useState2[0],
      setIntPhoneErrorCode = _useState2[1];

  var _useState3 = (0,react.useState)(),
      submittedEmail = _useState3[0],
      setSubmittedEmail = _useState3[1];
  /* eslint-disable camelcase */


  var schema = (0,react.useMemo)(function () {
    var _z$object;

    return lib/* object */.Ry((_z$object = {
      email: lib/* string */.Z_({
        required_error: FormFields/* companyEmailMessages.required */.BN.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(email/* default */.Z, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      })
      /* This is equal to .email( { message: companyEmailMessages.invalid }) but with a custom regex */
      .regex(sharedEmail/* default */.C, {
        message: FormFields/* companyEmailMessages.invalid */.BN.invalid
      }).regex(forbiddenEmail, {
        message: FormFields/* companyEmailMessages.forbiddenEmail */.BN.forbiddenEmail
      }),
      name: lib/* string */.Z_({
        required_error: FormFields/* fullNameMessages.required */.aZ.required
      }).regex(regexes_form/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }).regex(lastName/* default */.Z, {
        message: FormFields/* fullNameMessages.invalid */.aZ.invalid
      }),
      phone: lib/* string */.Z_({
        invalid_type_error: FormFields/* phoneNumberMessages.invalid */.NJ.invalid
      }).min(1, FormFields/* phoneNumberMessages.required */.NJ.required).refine(function () {
        return intPhoneErrorCode === undefined;
      }, {
        message: (0,FormFields/* getPhoneErrorMessage */.AP)(intPhoneErrorCode)
      })
    }, (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_VALID_FIELD */.tj, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_ERRORS_FIELD */.q5, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_CALLING_COUNTRY_CODE */.iZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_COUNTRY_CODE */.$l, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NUMBER */.SZ, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, FormFields/* TWILIO_PHONE_NATIONAL_FORMAT */.UN, lib/* string */.Z_().optional()), (0,defineProperty/* default */.Z)(_z$object, "company", lib/* string */.Z_({
      required_error: FormFields/* companyNameMessages.required */.qx.required
    }).regex(regexes_form/* default */.Z, {
      message: FormFields/* companyNameMessages.invalid */.qx.invalid
    })), _z$object));
  }, [intPhoneErrorCode]);
  /* eslint-enable camelcase */

  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  }); // Watch for personal email

  var watchedEmail = methods === null || methods === void 0 ? void 0 : methods.watch("email", ""); // If this is the progressive version of the form, set up email watching
  // Otherwise just always return true

  var showProgressiveFields = isProgressive ? Boolean(watchedEmail || emailCompleted) : true; // Mobile breakpoints

  var mobileResolutionMediaQuery = theme.breakpoints.down("md", false);
  var isSmallResolution = (0,useMatchMedia/* default */.Z)(mobileResolutionMediaQuery, true);
  (0,react.useEffect)(function () {
    if (watchedEmail) {
      setEmailCompleted(true);
      if (onEmailCompleted) onEmailCompleted();
    }
  }, [watchedEmail]);
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };

  var collectDriftFormData = function collectDriftFormData(formData) {
    var unTypedWindow = window;

    if (unTypedWindow.drift) {
      unTypedWindow.drift.api.collectFormData(_objectSpread(_objectSpread({}, formData), {}, {
        firstName: formData.name.split(" ")[0],
        lastName: formData.name.split(" ").slice(1).join(" ")
      }), {
        campaignId: driftCampaignId
      });
    }
  };

  (0,react.useEffect)(function () {
    if (methods.getValues("phone")) {
      methods.trigger("phone");
    }
  }, [intPhoneErrorCode]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: FORM_ID,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, _objectSpread(_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: isLeadEnrichmentFormEnabled ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {}) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message"
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, _objectSpread({
          form: "demo",
          status: "error",
          "data-hook": "demo-form-error-message"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: function onSubmit(data) {
          setSubmittedEmail(data.email);
          (0,helpers/* createDemoLead */.Ii)(data);

          if (driftCampaignId) {
            collectDriftFormData(data);
          }

          if (isSmallResolution && showProgressiveFields) {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, MOBILE_OFFSET, false);
          } else {
            (0,useScrollToAnchor/* scrollToAnchor */.d)(FORM_ID, DESKTOP_OFFSET, false);
          }
        },
        onFailure: helpers/* trackValidationErrorDemoForm */.nR,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier,
        customTrackingType: customTrackingType
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyEmailField */.Ot, {
          onBlur: helpers/* trackValidationErrorDemoForm */.nR
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* FullNameField */.AM, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* PhoneNumberField */.g8, {
            countryCode: countryCode,
            onValidate: setIntPhoneErrorCode,
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CompanyNameField */.wA, {
            onBlur: helpers/* trackValidationErrorDemoForm */.nR
          })]
        }), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: buttonText
          })
        }), showProgressiveFields && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DisclaimerWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
            data: customDisclaimer,
            appearance: successMessageAppearance
          })
        })]
      }))
    }), isLeadEnrichmentFormEnabled && methods.formState.isSubmitSuccessful && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressiveProfileForm/* ProgressiveProfileForm */.u, {
      before: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitMessage/* FormSubmitMessage */.f, {
        status: "success",
        form: "demo"
      }),
      email: submittedEmail,
      successMessage: successMessage
    })]
  });
};
/* harmony default export */ var DemoForm_DemoForm = ((/* unused pure expression or super */ null && (DemoForm)));
;// CONCATENATED MODULE: ../../libs/templates/Forms/DemoForm/index.ts


/***/ }),

/***/ 6612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ ProgressiveProfileForm; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ../../node_modules/@hookform/resolvers/zod/dist/zod.mjs + 1 modules
var zod = __webpack_require__(88883);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/templates/FormFields/index.ts + 22 modules
var FormFields = __webpack_require__(53790);
// EXTERNAL MODULE: ../../libs/templates/Disclaimer/index.ts + 3 modules
var Disclaimer = __webpack_require__(80401);
// EXTERNAL MODULE: ../../libs/templates/FormSubmitAction/index.ts + 2 modules
var FormSubmitAction = __webpack_require__(17433);
// EXTERNAL MODULE: ../../libs/templates/FormFields/JobTitle.tsx
var JobTitle = __webpack_require__(96321);
// EXTERNAL MODULE: ../../libs/templates/FormFields/Timeline.tsx
var Timeline = __webpack_require__(12307);
// EXTERNAL MODULE: ../../libs/templates/FormFields/MonthlyTraffic.tsx
var MonthlyTraffic = __webpack_require__(75886);
// EXTERNAL MODULE: ../../libs/templates/FormFields/CompanySize.tsx
var CompanySize = __webpack_require__(20417);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/FormFields/HiddenEmail.tsx


var _excluded = ["type", "name", "id", "className", "dataHook", "value"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




/**
 * Email hidden input for demo forms
 */

var HiddenEmailField = function HiddenEmailField(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "hidden" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      className = _ref.className,
      dataHook = _ref.dataHook,
      value = _ref.value,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useFormContext = (0,index_esm/* useFormContext */.Gc)(),
      register = _useFormContext.register;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
    "data-testid": "email",
    className: className,
    id: id,
    type: type,
    "data-hook": dataHook,
    value: value
  }, register(name, {})), rest));
};
// EXTERNAL MODULE: ../../libs/templates/TrackableForm/index.ts + 5 modules
var TrackableForm = __webpack_require__(53100);
// EXTERNAL MODULE: ../../libs/tracking/scripts/helpers.ts
var helpers = __webpack_require__(753);
// EXTERNAL MODULE: ../../libs/utils/useScrollToAnchor/index.ts
var useScrollToAnchor = __webpack_require__(68714);
// EXTERNAL MODULE: ../../libs/utils/regexes/form.ts
var regexes_form = __webpack_require__(63535);
// EXTERNAL MODULE: ../../libs/contexts/demo.tsx
var demo = __webpack_require__(805);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var FormWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja1"
} : 0)( true ? {
  name: "1flj9lk",
  styles: "text-align:left"
} : 0);
var ButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ebdrtja0"
} : 0)( true ? "" : 0);
;// CONCATENATED MODULE: ../../libs/templates/Forms/ProgressiveProfileForm/ProgressiveProfileForm.tsx



var ProgressiveProfileForm_excluded = ["appearance", "className", "before", "after", "overrideConsent", "customFormIdentifier", "successMessageAppearance", "email", "successMessage"];


function ProgressiveProfileForm_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function ProgressiveProfileForm_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ProgressiveProfileForm_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProgressiveProfileForm_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
























var BUTTON_TEXT = "Let's get started";
/* eslint-disable camelcase */

var schema = lib/* object */.Ry({
  jobTitle: lib/* string */.Z_({
    required_error: JobTitle/* jobTitleMessages.required */.cY.required
  }).regex(regexes_form/* default */.Z, {
    message: JobTitle/* jobTitleMessages.invalid */.cY.invalid
  }),
  companySize: lib/* string */.Z_({
    required_error: CompanySize/* companySizeMessages.required */.CF.required
  }),
  monthlyTraffic: lib/* string */.Z_({
    required_error: MonthlyTraffic/* monthlyTrafficMessages.required */.dn.required
  }),
  timeline: lib/* string */.Z_({
    required_error: Timeline/* timelineMessages.required */.Cb.required
  }),
  email: lib/* string */.Z_().optional()
});
/* eslint-enable camelcase */
// Set up demo form props since we define some of these props here in the template

var ProgressiveProfileForm = function ProgressiveProfileForm(_ref) {
  var appearance = _ref.appearance,
      className = _ref.className,
      before = _ref.before,
      after = _ref.after,
      _ref$overrideConsent = _ref.overrideConsent,
      overrideConsent = _ref$overrideConsent === void 0 ? true : _ref$overrideConsent,
      customFormIdentifier = _ref.customFormIdentifier,
      successMessageAppearance = _ref.successMessageAppearance,
      email = _ref.email,
      customSuccessMessage = _ref.successMessage,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ProgressiveProfileForm_excluded);

  var _usePageConfig = (0,page/* usePageConfig */.Gm)(),
      baseUrl = _usePageConfig.baseUrl;

  var formAppearance = (0,AppearanceContext/* useAppearance */.M)(appearance);
  var scrollTo = (0,useScrollToAnchor/* default */.Z)("progressive-profile-form", -200);

  var _useContext = (0,react.useContext)(demo/* DemoContext */.d),
      setCompletedFormData = _useContext.setCompletedFormData; // Initialize form here since we need the form initialized to handle progressive fields and the personal email functionality


  var methods = (0,index_esm/* useForm */.cI)({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
    resolver: (0,zod/* zodResolver */.F)(schema)
  });
  var successMessage = customSuccessMessage || {
    heading: "Thank you, you\u2019re all set!",
    description: "We'll get back to you shortly. For now, you can create your workspace by clicking below.",
    buttonUrl: "".concat(baseUrl, "/signup/?utm_campaign=demo"),
    buttonText: "Create your free workspace"
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: formAppearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormWrapper, {
      id: "progressive-profile-form",
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrackableForm/* default */.Z, ProgressiveProfileForm_objectSpread(ProgressiveProfileForm_objectSpread({
        gap: "small",
        methods: methods,
        className: className,
        before: before,
        after: after,
        success: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          form: "demo",
          status: "success",
          appearance: successMessageAppearance,
          "data-hook": "demo-signup-success-message",
          onButtonClick: function onButtonClick() {
            (0,helpers/* trackButtonClick */.kO)({
              buttonText: successMessage.buttonText,
              buttonId: "Workspace signup",
              targetUrl: successMessage.buttonUrl
            });
          }
        }, successMessage)),
        error: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormSubmitAction/* default */.Z, ProgressiveProfileForm_objectSpread({
          status: "error"
        }, TrackableForm/* errorMessage */.N)),
        onSubmit: /*#__PURE__*/function () {
          var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(data) {
            return regenerator_default().wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    setCompletedFormData(data);
                    _context.next = 3;
                    return (0,helpers/* trackProgressiveProfileForm */.NX)(data);

                  case 3:
                    scrollTo();

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }(),
        onFailure: helpers/* trackValidationErrorProgressiveProfileForm */.An,
        overrideConsent: overrideConsent,
        customFormIdentifier: customFormIdentifier
      }, rest), {}, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobTitle/* JobTitleField */.kL, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CompanySize/* CompanySizeSelectField */.BQ, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MonthlyTraffic/* MonthlyTrafficSelectField */.VW, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Timeline/* TimelineSelectField */.fz, {}), customFormIdentifier && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormFields/* CustomFormIdentifierField */.Fe, {
          value: customFormIdentifier
        }), email && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HiddenEmailField, {
          value: email
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
            color: "primary",
            variant: "filled",
            size: "large",
            expanded: true,
            children: BUTTON_TEXT
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Disclaimer/* default */.Z, {
          appearance: successMessageAppearance
        })]
      }))
    })
  });
};
/* harmony default export */ var ProgressiveProfileForm_ProgressiveProfileForm = ((/* unused pure expression or super */ null && (ProgressiveProfileForm)));

/***/ }),

/***/ 42576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ GettingStarted; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Button/index.ts
var Button = __webpack_require__(33445);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/SignupButton/index.ts
var SignupButton = __webpack_require__(77931);
// EXTERNAL MODULE: ../../libs/templates/LogoTiles/index.ts + 1 modules
var LogoTiles = __webpack_require__(20442);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/utils/getAbsoluteUrl/getAbsoluteUrl.ts
var getAbsoluteUrl = __webpack_require__(43848);
// EXTERNAL MODULE: ../../libs/contexts/page.ts
var page = __webpack_require__(17782);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.views.tsx

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v2"
} : 0)("overflow-y:auto;overflow-x:hidden;padding-top:80px;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";" + ( true ? "" : 0));
var Copy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v1"
} : 0)("display:grid;justify-content:center;row-gap:40px;padding:0 20px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 30px;}" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1044f9v0"
} : 0)("display:grid;max-width:540px;width:100%;margin:0 auto;grid-template-columns:1fr 1fr;grid-template-rows:auto;gap:24px;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.down("sm");
}, "{grid-template-columns:auto;max-width:327px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/GettingStarted.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}













var BaseGettingStarted = function BaseGettingStarted(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Getting started is easy" : _ref$heading,
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? "Start connecting your data with Segment." : _ref$description,
      _ref$demoUtms = _ref.demoUtms,
      demoUtms = _ref$demoUtms === void 0 ? "" : _ref$demoUtms,
      tokens = _ref.tokens;
  var pageConfig = (0,page/* usePageConfig */.Gm)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, _objectSpread(_objectSpread({}, tokens), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Copy, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h3",
          variant: "h2",
          children: heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
          size: "large",
          color: "primary",
          variant: "filled",
          tag: "a",
          href: (0,getAbsoluteUrl/* default */.Z)("/demo/".concat(demoUtms), pageConfig),
          children: "Get a demo"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignupButton/* default */.Z, {
          tag: "a",
          variant: "outlined",
          iconEnd: Common/* ChevronRightIcon */.XC,
          children: "Create a free account"
        })]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoTiles/* default */.Z, {})]
  }));
};

var GettingStarted = (0,useDesignTokens/* withDesignTokens */.Y)(BaseGettingStarted, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[10]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/templates/GettingStarted/index.ts


/***/ }),

/***/ 6087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ LogoCarousel_LogoCarousel; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/recipes/LogoCarousel/index.ts + 8 modules
var LogoCarousel = __webpack_require__(74595);
// EXTERNAL MODULE: ../../libs/templates/LogoCarousel/data.tsx
var data = __webpack_require__(43787);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/LogoCarousel.tsx


var _excluded = ["heading", "logos", "appearance", "headingVariant"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var getDefaultLogos = function getDefaultLogos(logosMap) {
  return [logosMap.DIGITAL_OCEAN, logosMap.IBM, logosMap.DOMINOS, logosMap.ANHEUSER_BUSCH, logosMap.VMWARE, logosMap.LEVIS, logosMap.LOG_ME_IN, logosMap.CLEAR_SCORE, logosMap.VACASA, logosMap.STAPLES, logosMap.INTUIT, logosMap.THE_SKIMM, logosMap.DRIFT, logosMap.ALLERGAN, logosMap.GLOSSIER, logosMap.AB_IN_BEV];
};

var LogoCarouselTemplate = function LogoCarouselTemplate(_ref) {
  var _ref$heading = _ref.heading,
      heading = _ref$heading === void 0 ? "Join the 25,000+ companies using the Segment platform" : _ref$heading,
      externalLogos = _ref.logos,
      externalAppearance = _ref.appearance,
      headingVariant = _ref.headingVariant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var finalLogos = externalLogos !== null && externalLogos !== void 0 ? externalLogos : getDefaultLogos(appearance === "twilioLight" ? data/* carouselLogos */.j : data/* carouselLogosMono */.G);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LogoCarousel/* default */.ZP, _objectSpread(_objectSpread({}, rest), {}, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* Heading */.X6, {
      variant: headingVariant,
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoCarousel/* LogoTrack */.xS, {
      icons: finalLogos
    })]
  }));
};

/* harmony default export */ var LogoCarousel_LogoCarousel = (LogoCarouselTemplate);
;// CONCATENATED MODULE: ../../libs/templates/LogoCarousel/index.ts


/***/ }),

/***/ 51895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lastName = /^(?![\s\S]*\s[;,?=+\-@])[^;,?=+\-@\s][\s\S]+$/g;
/* harmony default export */ __webpack_exports__["Z"] = (lastName);

/***/ }),

/***/ 93305:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industry/financial-services",
      function () {
        return __webpack_require__(37870);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 71926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useInterval = function (callback, delay) {
    var savedCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(function () { });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        savedCallback.current = callback;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (delay !== null) {
            var interval_1 = setInterval(function () { return savedCallback.current(); }, delay || 0);
            return function () { return clearInterval(interval_1); };
        }
        return undefined;
    }, [delay]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useInterval);


/***/ }),

/***/ 15250:
/***/ (function(module) {

module.exports = "/_next/static/images/OgSegmentIndustryFinancialServices-d16cb50b3b0235d9c9901ee16605ae22.png";

/***/ }),

/***/ 74613:
/***/ (function(module) {

module.exports = "/_next/static/images/CentralizeAndSimplify@2x-201bbfb45b9197c218127d9d51307f0d.png";

/***/ }),

/***/ 75394:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-cb2eb28da9d2da52c08b13a5f4af50db.png";

/***/ }),

/***/ 70532:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeInformedDecisions@2x-67c9310d62919cb57b81308477dbc78d.png";

/***/ }),

/***/ 98309:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizeEveryInteraction@2x-21559d77136ebb8b25f562b2a452e2e7.png";

/***/ }),

/***/ 9968:
/***/ (function(module) {

module.exports = "/_next/static/images/PropCardCta@2x-02037bace8d4bab9aab06786e90adce4.png";

/***/ }),

/***/ 30862:
/***/ (function(module) {

module.exports = "/_next/static/images/UseSegment@2x-4e2e7f39ebb750dbc52458ac8a466a3a.png";

/***/ }),

/***/ 77732:
/***/ (function(module) {

module.exports = "/_next/static/images/CentralizeAndSimplify-60f910ca99d7a18ae8f8271c1b6560d6.webp";

/***/ }),

/***/ 81355:
/***/ (function(module) {

module.exports = "/_next/static/images/CentralizeAndSimplify@2x-331439c332c6f44e3e938aeaaef9f99c.webp";

/***/ }),

/***/ 63270:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero-6f397bf4f3f5a880021ffcdad61ba9bd.webp";

/***/ }),

/***/ 70843:
/***/ (function(module) {

module.exports = "/_next/static/images/Hero@2x-57557b89b939a32fe5db297d7ae1e4c6.webp";

/***/ }),

/***/ 27286:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeInformedDecisions-272e338071d24d7a28b374cd686a412a.webp";

/***/ }),

/***/ 9841:
/***/ (function(module) {

module.exports = "/_next/static/images/MakeInformedDecisions@2x-5c3b93964981bb26c4b569e94b45bba3.webp";

/***/ }),

/***/ 27070:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizeEveryInteraction-1291f5f6a438cfc34a6890c1dd9e581a.webp";

/***/ }),

/***/ 52436:
/***/ (function(module) {

module.exports = "/_next/static/images/PersonalizeEveryInteraction@2x-e17f8542ea629e46d2b95e86818217ae.webp";

/***/ }),

/***/ 65347:
/***/ (function(module) {

module.exports = "/_next/static/images/PropCardCta-12d31cafd6945db4b3931cc71f55a293.webp";

/***/ }),

/***/ 9669:
/***/ (function(module) {

module.exports = "/_next/static/images/PropCardCta@2x-9772bd77b597ef9b3f922d8506902fb9.webp";

/***/ }),

/***/ 82738:
/***/ (function(module) {

module.exports = "/_next/static/images/UseSegment-26d153ce679347c7b88f667faa175ce5.webp";

/***/ }),

/***/ 41017:
/***/ (function(module) {

module.exports = "/_next/static/images/UseSegment@2x-4e2e7f39ebb750dbc52458ac8a466a3a.webp";

/***/ }),

/***/ 75536:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": function() { return /* binding */ useAnimation; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/hey-listen/dist/hey-listen.es.js
var hey_listen_es = __webpack_require__(9340);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/animation.mjs
var animation = __webpack_require__(59413);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/render/utils/setters.mjs + 3 modules
var setters = __webpack_require__(18617);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/animation-controls.mjs





/**
 * @public
 */
function animationControls() {
    /**
     * Track whether the host component has mounted.
     */
    var hasMounted = false;
    /**
     * Pending animations that are started before a component is mounted.
     * TODO: Remove this as animations should only run in effects
     */
    var pendingAnimations = [];
    /**
     * A collection of linked component animation controls.
     */
    var subscribers = new Set();
    var controls = {
        subscribe: function (visualElement) {
            subscribers.add(visualElement);
            return function () { return void subscribers.delete(visualElement); };
        },
        start: function (definition, transitionOverride) {
            /**
             * TODO: We only perform this hasMounted check because in Framer we used to
             * encourage the ability to start an animation within the render phase. This
             * isn't behaviour concurrent-safe so when we make Framer concurrent-safe
             * we can ditch this.
             */
            if (hasMounted) {
                var animations_1 = [];
                subscribers.forEach(function (visualElement) {
                    animations_1.push((0,animation/* animateVisualElement */.d5)(visualElement, definition, {
                        transitionOverride: transitionOverride,
                    }));
                });
                return Promise.all(animations_1);
            }
            else {
                return new Promise(function (resolve) {
                    pendingAnimations.push({
                        animation: [definition, transitionOverride],
                        resolve: resolve,
                    });
                });
            }
        },
        set: function (definition) {
            (0,hey_listen_es/* invariant */.k)(hasMounted, "controls.set() should only be called after a component has mounted. Consider calling within a useEffect hook.");
            return subscribers.forEach(function (visualElement) {
                (0,setters/* setValues */.gg)(visualElement, definition);
            });
        },
        stop: function () {
            subscribers.forEach(function (visualElement) {
                (0,animation/* stopAnimation */.p_)(visualElement);
            });
        },
        mount: function () {
            hasMounted = true;
            pendingAnimations.forEach(function (_a) {
                var animation = _a.animation, resolve = _a.resolve;
                controls.start.apply(controls, (0,tslib_es6/* __spreadArray */.ev)([], (0,tslib_es6/* __read */.CR)(animation), false)).then(resolve);
            });
            return function () {
                hasMounted = false;
                controls.stop();
            };
        },
    };
    return controls;
}



// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/animation/use-animation.mjs




/**
 * Creates `AnimationControls`, which can be used to manually start, stop
 * and sequence animations on one or more components.
 *
 * The returned `AnimationControls` should be passed to the `animate` property
 * of the components you want to animate.
 *
 * These components can then be animated with the `start` method.
 *
 * ```jsx
 * import * as React from 'react'
 * import { motion, useAnimation } from 'framer-motion'
 *
 * export function MyComponent(props) {
 *    const controls = useAnimation()
 *
 *    controls.start({
 *        x: 100,
 *        transition: { duration: 0.5 },
 *    })
 *
 *    return <motion.div animate={controls} />
 * }
 * ```
 *
 * @returns Animation controller with `start` and `stop` methods
 *
 * @public
 */
function useAnimation() {
    var controls = (0,use_constant/* useConstant */.h)(animationControls);
    (0,react.useEffect)(controls.mount, []);
    return controls;
}




/***/ }),

/***/ 66057:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useElementScroll; }
/* harmony export */ });
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3105);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7622);
/* harmony import */ var _events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27723);
/* harmony import */ var _utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23617);
/* harmony import */ var hey_listen__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9340);






var getElementScrollOffsets = function (element) { return function () {
    return {
        xOffset: element.scrollLeft,
        yOffset: element.scrollTop,
        xMaxOffset: element.scrollWidth - element.offsetWidth,
        yMaxOffset: element.scrollHeight - element.offsetHeight,
    };
}; };
/**
 * Returns MotionValues that update when the provided element scrolls:
 *
 * - `scrollX` — Horizontal scroll distance in pixels.
 * - `scrollY` — Vertical scroll distance in pixels.
 * - `scrollXProgress` — Horizontal scroll progress between `0` and `1`.
 * - `scrollYProgress` — Vertical scroll progress between `0` and `1`.
 *
 * This element must be set to `overflow: scroll` on either or both axes to report scroll offset.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const ref = useRef()
 *   const { scrollYProgress } = useElementScroll(ref)
 *
 *   return (
 *     <div ref={ref}>
 *       <motion.div style={{ scaleX: scrollYProgress }} />
 *     </div>
 *   )
 * }
 * ```
 *
 * @public
 */
function useElementScroll(ref) {
    var values = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useConstant */ .h)(_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollMotionValues */ .w);
    (0,_utils_use_isomorphic_effect_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useIsomorphicLayoutEffect */ .L)(function () {
        var element = ref.current;
        (0,hey_listen__WEBPACK_IMPORTED_MODULE_3__/* .invariant */ .k)(!!element, "ref provided to useScroll must be passed into a HTML element.");
        if (!element)
            return;
        var updateScrollValues = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .createScrollUpdater */ .S)(values, getElementScrollOffsets(element));
        var scrollListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "scroll", updateScrollValues);
        var resizeListener = (0,_events_use_dom_event_mjs__WEBPACK_IMPORTED_MODULE_4__/* .addDomEvent */ .E)(element, "resize", updateScrollValues);
        return function () {
            scrollListener && scrollListener();
            resizeListener && resizeListener();
        };
    }, []);
    return values;
}




/***/ }),

/***/ 7622:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ createScrollUpdater; },
/* harmony export */   "w": function() { return /* binding */ createScrollMotionValues; }
/* harmony export */ });
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40226);


function createScrollMotionValues() {
    return {
        scrollX: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollY: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollXProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
        scrollYProgress: (0,_index_mjs__WEBPACK_IMPORTED_MODULE_0__/* .motionValue */ .B)(0),
    };
}
function setProgress(offset, maxOffset, value) {
    value.set(!offset || !maxOffset ? 0 : offset / maxOffset);
}
function createScrollUpdater(values, getOffsets) {
    var update = function () {
        var _a = getOffsets(), xOffset = _a.xOffset, yOffset = _a.yOffset, xMaxOffset = _a.xMaxOffset, yMaxOffset = _a.yMaxOffset;
        // Set absolute positions
        values.scrollX.set(xOffset);
        values.scrollY.set(yOffset);
        // Set 0-1 progress
        setProgress(xOffset, xMaxOffset, values.scrollXProgress);
        setProgress(yOffset, yMaxOffset, values.scrollYProgress);
    };
    update();
    return update;
}




/***/ }),

/***/ 77014:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ useCombineMotionValues; }
/* harmony export */ });
/* harmony import */ var _use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21687);
/* harmony import */ var _use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29709);
/* harmony import */ var framesync__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76432);




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = (0,_use_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useMotionValue */ .c)(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    (0,_use_on_change_mjs__WEBPACK_IMPORTED_MODULE_2__/* .useMultiOnChange */ .f)(values, function () { return framesync__WEBPACK_IMPORTED_MODULE_0__/* ["default"].update */ .ZP.update(updateValue, false, true); });
    return value;
}




/***/ }),

/***/ 85770:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useMotionTemplate; }
/* harmony export */ });
/* harmony import */ var _use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77014);


/**
 * Combine multiple motion values into a new one using a string template literal.
 *
 * ```jsx
 * import {
 *   motion,
 *   useSpring,
 *   useMotionValue,
 *   useMotionTemplate
 * } from "framer-motion"
 *
 * function Component() {
 *   const shadowX = useSpring(0)
 *   const shadowY = useMotionValue(0)
 *   const shadow = useMotionTemplate`drop-shadow(${shadowX}px ${shadowY}px 20px rgba(0,0,0,0.3))`
 *
 *   return <motion.div style={{ filter: shadow }} />
 * }
 * ```
 *
 * @public
 */
function useMotionTemplate(fragments) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    /**
     * Create a function that will build a string from the latest motion values.
     */
    var numFragments = fragments.length;
    function buildValue() {
        var output = "";
        for (var i = 0; i < numFragments; i++) {
            output += fragments[i];
            var value = values[i];
            if (value)
                output += values[i].get();
        }
        return output;
    }
    return (0,_use_combine_values_mjs__WEBPACK_IMPORTED_MODULE_0__/* .useCombineMotionValues */ .N)(values, buildValue);
}




/***/ }),

/***/ 21687:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useMotionValue; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41412);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _index_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40226);
/* harmony import */ var _context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60976);
/* harmony import */ var _utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3105);






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,_utils_use_constant_mjs__WEBPACK_IMPORTED_MODULE_1__/* .useConstant */ .h)(function () { return (0,_index_mjs__WEBPACK_IMPORTED_MODULE_2__/* .motionValue */ .B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_context_MotionConfigContext_mjs__WEBPACK_IMPORTED_MODULE_3__/* .MotionConfigContext */ ._).isStatic;
    if (isStatic) {
        var _a = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__read */ .CR)((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}




/***/ }),

/***/ 29709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useMultiOnChange; },
/* harmony export */   "p": function() { return /* binding */ useOnChange; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15815);



function useOnChange(value, callback) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if ((0,_utils_is_motion_value_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isMotionValue */ .i)(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}




/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ useTransform; }
});

// EXTERNAL MODULE: ../../node_modules/framer-motion/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(41412);
// EXTERNAL MODULE: ../../node_modules/popmotion/dist/es/utils/interpolate.mjs + 3 modules
var interpolate = __webpack_require__(1560);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/value/use-combine-values.mjs
var use_combine_values = __webpack_require__(77014);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(3105);
;// CONCATENATED MODULE: ../../node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return (0,use_combine_values/* useCombineMotionValues */.N)(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,9137,3607,3254,9129,7209,1382,4136,2073,4274,7096,2429,1367,948,7303,3996,8187,8726,7960,6012,442,8392,1346,3379,5062,814,8302,3970,9774,2888,179], function() { return __webpack_exec__(93305); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);